//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiBase {
  authToken = '';
  protected constructor() { }

  setAuthToken(token: string) {
    this.authToken = token;
  }

  protected transformOptions(options: any): Promise<any> {
    console.log(options);
    if (this.authToken.length > 0) {
      options.headers['authorization'] = `Bearer ${this.authToken}`;
    }
    options.transformResponse = (data: any) => data;
    return Promise.resolve(options);
  }
}

export interface IAppClient {
    /**
     * Activate Item
     * @param body (optional) 
     * @return OK
     */
    activateTrackingUnit(body?: ActivateTrackingUnitCommandDto | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Deactivate Item
     * @param body (optional) 
     * @return OK
     */
    deactivateTrackingUnit(body?: DeactivateTrackingUnitCommandDto | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Event History for Tracking Unit
     * @return OK
     */
    globalSearch(search: string): Promise<GlobalSearchViewModelApiResultResponse>;
    /**
     * Load Item from Trailer
     * @param body (optional) 
     * @return OK
     */
    manifestLoad(manifestId: string, body?: LoadItemCommandDto | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Get item from Manifest Queue
     * @return OK
     */
    manifestGetQueueItem(manifestId: string, barcode: string): Promise<LineitemQueueDtoApiResultResponse>;
    /**
     * Get Manifest ID's for list
     * @return OK
     */
    manifestIdList(search: string): Promise<ActiveManifestsForListViewModelApiResultResponse>;
    /**
     * Get Manifest Preview
     * @return OK
     */
    manifestPreview(manifestId: string): Promise<ManifestPreviewViewModelApiResultResponse>;
    /**
     * Get Pros for Manifest Preview
     * @return OK
     */
    manifestPreviewPros(manifestId: string): Promise<ManifestProsViewModelApiResultResponse>;
    /**
     * Get Manifest Preview
     * @return OK
     */
    manifestQueue(manifestId: string): Promise<QueueDtoApiResultResponse>;
    /**
     * Get Manifest Preview
     * @param body (optional) 
     * @return OK
     */
    manifestQueueHistory(manifestId: string, body?: LazyLoadEvent | undefined): Promise<ManifestQueueHistoryDtoPaginatedResultApiResultResponse>;
    /**
     * Get Pro Numbers for list
     * @return OK
     */
    proNumbersList(search: string): Promise<ActiveProNumbersForListViewModelApiResultResponse>;
    /**
     * Relocate Item Legacy
     * @param body (optional) 
     * @return OK
     */
    relocateItem(body?: RelocateItemCommandDto | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Relocate Item
     * @param body (optional) 
     * @return OK
     */
    relocateItemV2(body?: RelocateItemV2Command | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Scan Item
     * @param body (optional) 
     * @return OK
     */
    scanTrackingUnit(body?: ScanTrackingUnitCommandDto | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Stow Item
     * @param body (optional) 
     * @return OK
     */
    manifestStow(manifestId: string, body?: StowItemCommandDto | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Get Pros for Manifest Preview
     * @return OK
     */
    trackingUnitDetail(barcode: string): Promise<TrackingUnitDetailViewModelApiResultResponse>;
    /**
     * Get Tracking Unit Exception Status Logs
     * @param body (optional) 
     * @return OK
     */
    trackingUnitExceptionLogs(id: string, body?: LazyLoadEvent | undefined): Promise<TrackingUnitExceptionLogPaginatedResultApiResultResponse>;
    /**
     * Event History for Tracking Unit
     * @return OK
     */
    trackingUnitHistory(barcode: string): Promise<TrackingUnitHistoryApiResultResponse>;
    /**
     * Unload Item from Trailer
     * @param body (optional) 
     * @return OK
     */
    manifestUnload(manifestId: string, body?: UnloadItemCommandDto | undefined): Promise<UnloadItemCommandResponseApiResultResponse>;
}

export class AppClient extends ApiBase implements IAppClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Activate Item
     * @param body (optional) 
     * @return OK
     */
    activateTrackingUnit(body?: ActivateTrackingUnitCommandDto | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ActivateTrackingUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateTrackingUnit(_response);
        });
    }

    protected processActivateTrackingUnit(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Deactivate Item
     * @param body (optional) 
     * @return OK
     */
    deactivateTrackingUnit(body?: DeactivateTrackingUnitCommandDto | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/DeactivateTrackingUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateTrackingUnit(_response);
        });
    }

    protected processDeactivateTrackingUnit(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Event History for Tracking Unit
     * @return OK
     */
    globalSearch(search: string, cancelToken?: CancelToken): Promise<GlobalSearchViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/GlobalSearch/{search}";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined.");
        url_ = url_.replace("{search}", encodeURIComponent("" + search));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGlobalSearch(_response);
        });
    }

    protected processGlobalSearch(response: AxiosResponse): Promise<GlobalSearchViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GlobalSearchViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GlobalSearchViewModelApiResultResponse>(null as any);
    }

    /**
     * Load Item from Trailer
     * @param body (optional) 
     * @return OK
     */
    manifestLoad(manifestId: string, body?: LoadItemCommandDto | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/Load/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestLoad(_response);
        });
    }

    protected processManifestLoad(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Get item from Manifest Queue
     * @return OK
     */
    manifestGetQueueItem(manifestId: string, barcode: string, cancelToken?: CancelToken): Promise<LineitemQueueDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/Load/{manifestId}/queue/{barcode}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestGetQueueItem(_response);
        });
    }

    protected processManifestGetQueueItem(response: AxiosResponse): Promise<LineitemQueueDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LineitemQueueDtoApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LineitemQueueDtoApiResultResponse>(null as any);
    }

    /**
     * Get Manifest ID's for list
     * @return OK
     */
    manifestIdList(search: string, cancelToken?: CancelToken): Promise<ActiveManifestsForListViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ManifestIdList/{search}";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined.");
        url_ = url_.replace("{search}", encodeURIComponent("" + search));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestIdList(_response);
        });
    }

    protected processManifestIdList(response: AxiosResponse): Promise<ActiveManifestsForListViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ActiveManifestsForListViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveManifestsForListViewModelApiResultResponse>(null as any);
    }

    /**
     * Get Manifest Preview
     * @return OK
     */
    manifestPreview(manifestId: string, cancelToken?: CancelToken): Promise<ManifestPreviewViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ManifestPreview/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestPreview(_response);
        });
    }

    protected processManifestPreview(response: AxiosResponse): Promise<ManifestPreviewViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestPreviewViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestPreviewViewModelApiResultResponse>(null as any);
    }

    /**
     * Get Pros for Manifest Preview
     * @return OK
     */
    manifestPreviewPros(manifestId: string, cancelToken?: CancelToken): Promise<ManifestProsViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ManifestPreviewPros/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestPreviewPros(_response);
        });
    }

    protected processManifestPreviewPros(response: AxiosResponse): Promise<ManifestProsViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestProsViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestProsViewModelApiResultResponse>(null as any);
    }

    /**
     * Get Manifest Preview
     * @return OK
     */
    manifestQueue(manifestId: string, cancelToken?: CancelToken): Promise<QueueDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ManifestQueue/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestQueue(_response);
        });
    }

    protected processManifestQueue(response: AxiosResponse): Promise<QueueDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<QueueDtoApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueDtoApiResultResponse>(null as any);
    }

    /**
     * Get Manifest Preview
     * @param body (optional) 
     * @return OK
     */
    manifestQueueHistory(manifestId: string, body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ManifestQueueHistoryDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ManifestQueueHistory/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestQueueHistory(_response);
        });
    }

    protected processManifestQueueHistory(response: AxiosResponse): Promise<ManifestQueueHistoryDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestQueueHistoryDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestQueueHistoryDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Get Pro Numbers for list
     * @return OK
     */
    proNumbersList(search: string, cancelToken?: CancelToken): Promise<ActiveProNumbersForListViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ProNumbersList/{search}";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined.");
        url_ = url_.replace("{search}", encodeURIComponent("" + search));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProNumbersList(_response);
        });
    }

    protected processProNumbersList(response: AxiosResponse): Promise<ActiveProNumbersForListViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ActiveProNumbersForListViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveProNumbersForListViewModelApiResultResponse>(null as any);
    }

    /**
     * Relocate Item Legacy
     * @param body (optional) 
     * @return OK
     */
    relocateItem(body?: RelocateItemCommandDto | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/RelocateItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRelocateItem(_response);
        });
    }

    protected processRelocateItem(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Relocate Item
     * @param body (optional) 
     * @return OK
     */
    relocateItemV2(body?: RelocateItemV2Command | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/RelocateItemV2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRelocateItemV2(_response);
        });
    }

    protected processRelocateItemV2(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Scan Item
     * @param body (optional) 
     * @return OK
     */
    scanTrackingUnit(body?: ScanTrackingUnitCommandDto | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ScanTrackingUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScanTrackingUnit(_response);
        });
    }

    protected processScanTrackingUnit(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Stow Item
     * @param body (optional) 
     * @return OK
     */
    manifestStow(manifestId: string, body?: StowItemCommandDto | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/Stow/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestStow(_response);
        });
    }

    protected processManifestStow(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Get Pros for Manifest Preview
     * @return OK
     */
    trackingUnitDetail(barcode: string, cancelToken?: CancelToken): Promise<TrackingUnitDetailViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/TrackingUnitDetail/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrackingUnitDetail(_response);
        });
    }

    protected processTrackingUnitDetail(response: AxiosResponse): Promise<TrackingUnitDetailViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TrackingUnitDetailViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackingUnitDetailViewModelApiResultResponse>(null as any);
    }

    /**
     * Get Tracking Unit Exception Status Logs
     * @param body (optional) 
     * @return OK
     */
    trackingUnitExceptionLogs(id: string, body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<TrackingUnitExceptionLogPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/TrackingUnitExceptionLogs/trackingunit/{id}/logs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrackingUnitExceptionLogs(_response);
        });
    }

    protected processTrackingUnitExceptionLogs(response: AxiosResponse): Promise<TrackingUnitExceptionLogPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TrackingUnitExceptionLogPaginatedResultApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackingUnitExceptionLogPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Event History for Tracking Unit
     * @return OK
     */
    trackingUnitHistory(barcode: string, cancelToken?: CancelToken): Promise<TrackingUnitHistoryApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/TrackingUnitHistory/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrackingUnitHistory(_response);
        });
    }

    protected processTrackingUnitHistory(response: AxiosResponse): Promise<TrackingUnitHistoryApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TrackingUnitHistoryApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackingUnitHistoryApiResultResponse>(null as any);
    }

    /**
     * Unload Item from Trailer
     * @param body (optional) 
     * @return OK
     */
    manifestUnload(manifestId: string, body?: UnloadItemCommandDto | undefined, cancelToken?: CancelToken): Promise<UnloadItemCommandResponseApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/Unload/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestUnload(_response);
        });
    }

    protected processManifestUnload(response: AxiosResponse): Promise<UnloadItemCommandResponseApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UnloadItemCommandResponseApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnloadItemCommandResponseApiResultResponse>(null as any);
    }
}

export interface IOSDClient {
    /**
     * Damage Item
     * @param body (optional) 
     * @return OK
     */
    damage(body?: DamageItemCommand | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Destroy Item
     * @param body (optional) 
     * @return OK
     */
    destroy(body?: DestroyItemCommand | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Orphan Item
     * @param body (optional) 
     * @return OK
     */
    orphan(body?: OrphanItemCommand | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Short Item
     * @param body (optional) 
     * @return OK
     */
    shortItem(body?: ShortItemCommand | undefined): Promise<CommandResultApiResultResponse>;
    /**
     * Short Items
     * @param body (optional) 
     * @return OK
     */
    shortItems(body?: ShortItemsCommand | undefined): Promise<CommandResultApiResultResponse>;
}

export class OSDClient extends ApiBase implements IOSDClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Damage Item
     * @param body (optional) 
     * @return OK
     */
    damage(body?: DamageItemCommand | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/Damage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDamage(_response);
        });
    }

    protected processDamage(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Destroy Item
     * @param body (optional) 
     * @return OK
     */
    destroy(body?: DestroyItemCommand | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/Destroy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDestroy(_response);
        });
    }

    protected processDestroy(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Orphan Item
     * @param body (optional) 
     * @return OK
     */
    orphan(body?: OrphanItemCommand | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/Orphan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrphan(_response);
        });
    }

    protected processOrphan(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Short Item
     * @param body (optional) 
     * @return OK
     */
    shortItem(body?: ShortItemCommand | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ShortItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShortItem(_response);
        });
    }

    protected processShortItem(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }

    /**
     * Short Items
     * @param body (optional) 
     * @return OK
     */
    shortItems(body?: ShortItemsCommand | undefined, cancelToken?: CancelToken): Promise<CommandResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/App/ShortItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShortItems(_response);
        });
    }

    protected processShortItems(response: AxiosResponse): Promise<CommandResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResultApiResultResponse>(null as any);
    }
}

export interface IAuthenticateClient {
    /**
     * Add User Role
     * @param body (optional) 
     * @return OK
     */
    addRole(body?: UpdateUserRoleModel | undefined): Promise<AuthenticateResponse>;
    /**
     * Set User Role
     * @param body (optional)
     * @return OK
     */
    setRole(body?: UpdateUserRoleModel | undefined): Promise<AuthenticateResponse>;
    /**
     * User authentication
     * @param body (optional) 
     * @return Success: returns a JWT Token
     */
    login(body?: AuthenticateRequest | undefined): Promise<AuthorizedResponseApiResultResponse>;
    /**
     * User Registration
     * @param body (optional) 
     * @return OK
     */
    register(body?: RegisterModel | undefined): Promise<AuthenticateResponse>;
    registerAdmin(body?: RegisterModel | undefined): Promise<void>;
    /**
     * Update Registration
     * @param body (optional) 
     * @return OK
     */
    updateRegistration(body?: UpdateRegistrationModel | undefined): Promise<AuthenticateResponse>;
    /**
     * Add User Role
     * @param body (optional) 
     * @return OK
     */
    removeRole(body?: UpdateUserRoleModel | undefined): Promise<AuthenticateResponse>;
    /**
     * Update Password
     * @param body (optional) 
     * @return OK
     */
    updatePassword(body?: UpdatePasswordModel | undefined): Promise<AuthenticateResponse>;
    /**
     * Paginated User List
     * @param body (optional) 
     * @return OK
     */
    paginatedUserList(body?: PaginationFilter | undefined): Promise<ApplicationUserWithRolesPaginatedListApiResultResponse>;
}

export class AuthenticateClient extends ApiBase implements IAuthenticateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Add User Role
     * @param body (optional) 
     * @return OK
     */
    addRole(body?: UpdateUserRoleModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/addRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRole(_response);
        });
    }

    protected processAddRole(response: AxiosResponse): Promise<AuthenticateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuthenticateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResponse>(null as any);
    }

    /**
     * Set User Role
     * @param body (optional)
     * @return OK
     *
     * BBatts: hand-written to match the SetRole operation on AuthenticateController until this
     * file is next regenerated from Swagger, at which point NSwag emits the same method.
     */
    setRole(body?: UpdateUserRoleModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/setRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRole(_response);
        });
    }

    protected processSetRole(response: AxiosResponse): Promise<AuthenticateResponse> {
        return this.processAddRole(response);
    }

    /**
     * User authentication
     * @param body (optional) 
     * @return Success: returns a JWT Token
     */
    login(body?: AuthenticateRequest | undefined, cancelToken?: CancelToken): Promise<AuthorizedResponseApiResultResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthorizedResponseApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized: the login failed", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuthorizedResponseApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthorizedResponseApiResultResponse>(null as any);
    }

    /**
     * User Registration
     * @param body (optional) 
     * @return OK
     */
    register(body?: RegisterModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<AuthenticateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuthenticateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResponse>(null as any);
    }

    registerAdmin(body?: RegisterModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Authenticate/register-admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterAdmin(_response);
        });
    }

    protected processRegisterAdmin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update Registration
     * @param body (optional) 
     * @return OK
     */
    updateRegistration(body?: UpdateRegistrationModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/registrationUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRegistration(_response);
        });
    }

    protected processUpdateRegistration(response: AxiosResponse): Promise<AuthenticateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuthenticateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResponse>(null as any);
    }

    /**
     * Add User Role
     * @param body (optional) 
     * @return OK
     */
    removeRole(body?: UpdateUserRoleModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/removeRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRole(_response);
        });
    }

    protected processRemoveRole(response: AxiosResponse): Promise<AuthenticateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuthenticateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResponse>(null as any);
    }

    /**
     * Update Password
     * @param body (optional) 
     * @return OK
     */
    updatePassword(body?: UpdatePasswordModel | undefined, cancelToken?: CancelToken): Promise<AuthenticateResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/updatepassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<AuthenticateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AuthenticateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResponse>(null as any);
    }

    /**
     * Paginated User List
     * @param body (optional) 
     * @return OK
     */
    paginatedUserList(body?: PaginationFilter | undefined, cancelToken?: CancelToken): Promise<ApplicationUserWithRolesPaginatedListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Authenticate/users/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPaginatedUserList(_response);
        });
    }

    protected processPaginatedUserList(response: AxiosResponse): Promise<ApplicationUserWithRolesPaginatedListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApplicationUserWithRolesPaginatedListApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationUserWithRolesPaginatedListApiResultResponse>(null as any);
    }
}

export interface ICorporateClient {
    /**
     * Get List of Doors
     * @return OK
     */
    doorsList(): Promise<DoorDtoListApiResultResponse>;
    /**
     * Add Door
     * @param body (optional) 
     * @return OK
     */
    newDoor(body?: DoorDto | undefined): Promise<boolean>;
    /**
     * Get List of Doors for a Terminal
     * @return OK
     */
    doorsByTerminalList(terminal: string): Promise<HubTerminalDtoListApiResultResponse>;
    /**
     * Get List of Lanes
     * @return OK
     */
    lanesList(): Promise<LaneDtoListApiResultResponse>;
    /**
     * Upsert Lanes
     * @param body (optional) 
     * @return OK
     */
    newLane(body?: UpsertLaneDto | undefined): Promise<boolean>;
    /**
     * Remove Lane
     * @return OK
     */
    removeLane(code: string): Promise<boolean>;
    /**
     * Get single lane
     * @return OK
     */
    getLane(lane: string): Promise<LaneDtoApiResultResponse>;
    /**
     * Get List of Locations
     * @return OK
     */
    locationsList(): Promise<LocationDtoListApiResultResponse>;
    /**
     * Add Location
     * @param body (optional) 
     * @return OK
     */
    newLocation(body?: LocationDto | undefined): Promise<boolean>;
    /**
     * Remove Location
     * @return OK
     */
    removeLocation(code: string): Promise<boolean>;
    /**
     * Get List of Locations
     * @return OK
     */
    locationsByTerminalList(terminal: string): Promise<LocationDtoListApiResultResponse>;
    /**
     * Get List of Locations grouped by row bay
     * @return OK
     */
    locationsByTerminalListGrouped(terminal: string): Promise<LocationsListByTerminalGroupedViewModelApiResultResponse>;
    /**
     * Get List of HubTerminals
     * @param includeInactive (optional) 
     * @return OK
     */
    hubTerminalsList(includeInactive?: boolean | undefined): Promise<HubTerminalDtoListApiResultResponse>;
    /**
     * Add Terminal
     * @param body (optional) 
     * @return OK
     */
    newTerminal(body?: HubTerminalDto | undefined): Promise<boolean>;
    /**
     * Get List of Zones
     * @return OK
     */
    zonesList(): Promise<ZoneDtoListApiResultResponse>;
    /**
     * Add zone
     * @param body (optional) 
     * @return OK
     */
    newZone(body?: ZoneDto | undefined): Promise<boolean>;
    /**
     * Get List of Zones
     * @return OK
     */
    getZone(zone: string): Promise<ZoneDtoApiResultResponse>;
}

export class CorporateClient extends ApiBase implements ICorporateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get List of Doors
     * @return OK
     */
    doorsList( cancelToken?: CancelToken): Promise<DoorDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/doors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoorsList(_response);
        });
    }

    protected processDoorsList(response: AxiosResponse): Promise<DoorDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DoorDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DoorDtoListApiResultResponse>(null as any);
    }

    /**
     * Add Door
     * @param body (optional) 
     * @return OK
     */
    newDoor(body?: DoorDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Corporate/doors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewDoor(_response);
        });
    }

    protected processNewDoor(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get List of Doors for a Terminal
     * @return OK
     */
    doorsByTerminalList(terminal: string, cancelToken?: CancelToken): Promise<HubTerminalDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/doors/{terminal}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDoorsByTerminalList(_response);
        });
    }

    protected processDoorsByTerminalList(response: AxiosResponse): Promise<HubTerminalDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HubTerminalDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubTerminalDtoListApiResultResponse>(null as any);
    }

    /**
     * Get List of Lanes
     * @return OK
     */
    lanesList( cancelToken?: CancelToken): Promise<LaneDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/lanes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLanesList(_response);
        });
    }

    protected processLanesList(response: AxiosResponse): Promise<LaneDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LaneDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LaneDtoListApiResultResponse>(null as any);
    }

    /**
     * Upsert Lanes
     * @param body (optional) 
     * @return OK
     */
    newLane(body?: UpsertLaneDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Corporate/lanes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewLane(_response);
        });
    }

    protected processNewLane(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Remove Lane
     * @return OK
     */
    removeLane(code: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Corporate/lanes/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveLane(_response);
        });
    }

    protected processRemoveLane(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get single lane
     * @return OK
     */
    getLane(lane: string, cancelToken?: CancelToken): Promise<LaneDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/lanes/{lane}";
        if (lane === undefined || lane === null)
            throw new Error("The parameter 'lane' must be defined.");
        url_ = url_.replace("{lane}", encodeURIComponent("" + lane));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLane(_response);
        });
    }

    protected processGetLane(response: AxiosResponse): Promise<LaneDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LaneDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LaneDtoApiResultResponse>(null as any);
    }

    /**
     * Get List of Locations
     * @return OK
     */
    locationsList( cancelToken?: CancelToken): Promise<LocationDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationsList(_response);
        });
    }

    protected processLocationsList(response: AxiosResponse): Promise<LocationDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationDtoListApiResultResponse>(null as any);
    }

    /**
     * Add Location
     * @param body (optional) 
     * @return OK
     */
    newLocation(body?: LocationDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Corporate/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewLocation(_response);
        });
    }

    protected processNewLocation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Remove Location
     * @return OK
     */
    removeLocation(code: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Corporate/locations/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveLocation(_response);
        });
    }

    protected processRemoveLocation(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get List of Locations
     * @return OK
     */
    locationsByTerminalList(terminal: string, cancelToken?: CancelToken): Promise<LocationDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/locations/{terminal}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationsByTerminalList(_response);
        });
    }

    protected processLocationsByTerminalList(response: AxiosResponse): Promise<LocationDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationDtoListApiResultResponse>(null as any);
    }

    /**
     * Get List of Locations grouped by row bay
     * @return OK
     */
    locationsByTerminalListGrouped(terminal: string, cancelToken?: CancelToken): Promise<LocationsListByTerminalGroupedViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/locations/grouped/{terminal}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationsByTerminalListGrouped(_response);
        });
    }

    protected processLocationsByTerminalListGrouped(response: AxiosResponse): Promise<LocationsListByTerminalGroupedViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LocationsListByTerminalGroupedViewModelApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationsListByTerminalGroupedViewModelApiResultResponse>(null as any);
    }

    /**
     * Get List of HubTerminals
     * @param includeInactive (optional) 
     * @return OK
     */
    hubTerminalsList(includeInactive?: boolean | undefined, cancelToken?: CancelToken): Promise<HubTerminalDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/terminals?";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHubTerminalsList(_response);
        });
    }

    protected processHubTerminalsList(response: AxiosResponse): Promise<HubTerminalDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<HubTerminalDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HubTerminalDtoListApiResultResponse>(null as any);
    }

    /**
     * Add Terminal
     * @param body (optional) 
     * @return OK
     */
    newTerminal(body?: HubTerminalDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Corporate/terminals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewTerminal(_response);
        });
    }

    protected processNewTerminal(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get List of Zones
     * @return OK
     */
    zonesList( cancelToken?: CancelToken): Promise<ZoneDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/zone";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processZonesList(_response);
        });
    }

    protected processZonesList(response: AxiosResponse): Promise<ZoneDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ZoneDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZoneDtoListApiResultResponse>(null as any);
    }

    /**
     * Add zone
     * @param body (optional) 
     * @return OK
     */
    newZone(body?: ZoneDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Corporate/zone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewZone(_response);
        });
    }

    protected processNewZone(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get List of Zones
     * @return OK
     */
    getZone(zone: string, cancelToken?: CancelToken): Promise<ZoneDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/zone/{zone}";
        if (zone === undefined || zone === null)
            throw new Error("The parameter 'zone' must be defined.");
        url_ = url_.replace("{zone}", encodeURIComponent("" + zone));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetZone(_response);
        });
    }

    protected processGetZone(response: AxiosResponse): Promise<ZoneDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ZoneDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ZoneDtoApiResultResponse>(null as any);
    }
}

export interface IReportsClient {
    /**
     * Gets report dimensions for terminal productivity
     * @param period (optional) 
     * @param periodStart (optional) 
     * @param periodEnd (optional) 
     * @return OK
     */
    getTerminalProductivityReport(terminal: string, period?: ReportingPeriod | undefined, periodStart?: Date | undefined, periodEnd?: Date | undefined): Promise<TerminalProductivityViewModelApiResultResponse>;
    /**
     * Gets report dimensions for terminal productivity
     * @return OK
     */
    getTodaysTerminalProductivity(): Promise<TerminalProductivityViewModelApiResultResponse>;
}

export class ReportsClient extends ApiBase implements IReportsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Gets report dimensions for terminal productivity
     * @param period (optional) 
     * @param periodStart (optional) 
     * @param periodEnd (optional) 
     * @return OK
     */
    getTerminalProductivityReport(terminal: string, period?: ReportingPeriod | undefined, periodStart?: Date | undefined, periodEnd?: Date | undefined, cancelToken?: CancelToken): Promise<TerminalProductivityViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/report/productivity/terminal/{terminal}?";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        if (periodStart === null)
            throw new Error("The parameter 'periodStart' cannot be null.");
        else if (periodStart !== undefined)
            url_ += "periodStart=" + encodeURIComponent(periodStart ? "" + periodStart.toISOString() : "") + "&";
        if (periodEnd === null)
            throw new Error("The parameter 'periodEnd' cannot be null.");
        else if (periodEnd !== undefined)
            url_ += "periodEnd=" + encodeURIComponent(periodEnd ? "" + periodEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTerminalProductivityReport(_response);
        });
    }

    protected processGetTerminalProductivityReport(response: AxiosResponse): Promise<TerminalProductivityViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TerminalProductivityViewModelApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TerminalProductivityViewModelApiResultResponse>(null as any);
    }

    /**
     * Gets report dimensions for terminal productivity
     * @return OK
     */
    getTodaysTerminalProductivity( cancelToken?: CancelToken): Promise<TerminalProductivityViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/Corporate/report/productivity/today";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodaysTerminalProductivity(_response);
        });
    }

    protected processGetTodaysTerminalProductivity(response: AxiosResponse): Promise<TerminalProductivityViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TerminalProductivityViewModelApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TerminalProductivityViewModelApiResultResponse>(null as any);
    }
}

export interface IEventsClient {
    /**
     * Get Manifest Events
     * @return OK
     */
    manifestEvents(streamId: string): Promise<ListManifestEventsViewModelListApiResultResponse>;
    /**
     * Get Manifest Events
     * @return OK
     */
    manifestEventsAtVersion(streamId: string, version: number): Promise<ListManifestEventsViewModelListApiResultResponse>;
    /**
     * Get Manifest Events by Range
     * @return OK
     */
    manifestEventsRange(streamId: string, version: number, from: number): Promise<ListManifestEventsViewModelListApiResultResponse>;
    /**
     * Get Pro Events
     * @return OK
     */
    proEvents(streamId: string): Promise<ListProEventsViewModelListApiResultResponse>;
}

export class EventsClient extends ApiBase implements IEventsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get Manifest Events
     * @return OK
     */
    manifestEvents(streamId: string, cancelToken?: CancelToken): Promise<ListManifestEventsViewModelListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Events/manifest/{streamId}";
        if (streamId === undefined || streamId === null)
            throw new Error("The parameter 'streamId' must be defined.");
        url_ = url_.replace("{streamId}", encodeURIComponent("" + streamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestEvents(_response);
        });
    }

    protected processManifestEvents(response: AxiosResponse): Promise<ListManifestEventsViewModelListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ListManifestEventsViewModelListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListManifestEventsViewModelListApiResultResponse>(null as any);
    }

    /**
     * Get Manifest Events
     * @return OK
     */
    manifestEventsAtVersion(streamId: string, version: number, cancelToken?: CancelToken): Promise<ListManifestEventsViewModelListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Events/manifest/{streamId}/version/{version}";
        if (streamId === undefined || streamId === null)
            throw new Error("The parameter 'streamId' must be defined.");
        url_ = url_.replace("{streamId}", encodeURIComponent("" + streamId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestEventsAtVersion(_response);
        });
    }

    protected processManifestEventsAtVersion(response: AxiosResponse): Promise<ListManifestEventsViewModelListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ListManifestEventsViewModelListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListManifestEventsViewModelListApiResultResponse>(null as any);
    }

    /**
     * Get Manifest Events by Range
     * @return OK
     */
    manifestEventsRange(streamId: string, version: number, from: number, cancelToken?: CancelToken): Promise<ListManifestEventsViewModelListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Events/manifest/{streamId}/version/{version}/{from}";
        if (streamId === undefined || streamId === null)
            throw new Error("The parameter 'streamId' must be defined.");
        url_ = url_.replace("{streamId}", encodeURIComponent("" + streamId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent("" + from));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestEventsRange(_response);
        });
    }

    protected processManifestEventsRange(response: AxiosResponse): Promise<ListManifestEventsViewModelListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ListManifestEventsViewModelListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListManifestEventsViewModelListApiResultResponse>(null as any);
    }

    /**
     * Get Pro Events
     * @return OK
     */
    proEvents(streamId: string, cancelToken?: CancelToken): Promise<ListProEventsViewModelListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Events/pro/{streamId}";
        if (streamId === undefined || streamId === null)
            throw new Error("The parameter 'streamId' must be defined.");
        url_ = url_.replace("{streamId}", encodeURIComponent("" + streamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProEvents(_response);
        });
    }

    protected processProEvents(response: AxiosResponse): Promise<ListProEventsViewModelListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ListProEventsViewModelListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListProEventsViewModelListApiResultResponse>(null as any);
    }
}

export interface IInventoryClient {
    /**
     * Get Inventory for Bay from location barcode
     * @return OK
     */
    getInventoryByBarcode(barcode: string): Promise<GetInventoryForBayViewModelApiResultResponse>;
    /**
     * Get Inventory for Terminal
     * @return OK
     */
    getInventoryByTerminal(terminal: string): Promise<GetInventoryForBayViewModelApiResultResponse>;
    /**
     * Get CSV file for  Inventory for Terminal
     * @return OK
     */
    exportInventoryForTerminal(terminal: string): Promise<FileResponse>;
    /**
     * Get Inventory for Bay
     * @return OK
     */
    getInventoryForBay(terminal: string, row: string, bay: string): Promise<GetInventoryForBayViewModelApiResultResponse>;
    /**
     * Validate Inventory Item
     * @param body (optional) 
     */
    validateInventory(barcode: string, body?: ValidateCommandDto | undefined): Promise<void>;
}

export class InventoryClient extends ApiBase implements IInventoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get Inventory for Bay from location barcode
     * @return OK
     */
    getInventoryByBarcode(barcode: string, cancelToken?: CancelToken): Promise<GetInventoryForBayViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/Inventory/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInventoryByBarcode(_response);
        });
    }

    protected processGetInventoryByBarcode(response: AxiosResponse): Promise<GetInventoryForBayViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetInventoryForBayViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInventoryForBayViewModelApiResultResponse>(null as any);
    }

    /**
     * Get Inventory for Terminal
     * @return OK
     */
    getInventoryByTerminal(terminal: string, cancelToken?: CancelToken): Promise<GetInventoryForBayViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/Inventory/terminal/{terminal}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInventoryByTerminal(_response);
        });
    }

    protected processGetInventoryByTerminal(response: AxiosResponse): Promise<GetInventoryForBayViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetInventoryForBayViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInventoryForBayViewModelApiResultResponse>(null as any);
    }

    /**
     * Get CSV file for  Inventory for Terminal
     * @return OK
     */
    exportInventoryForTerminal(terminal: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Inventory/terminal/{terminal}/csv";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportInventoryForTerminal(_response);
        });
    }

    protected processExportInventoryForTerminal(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get Inventory for Bay
     * @return OK
     */
    getInventoryForBay(terminal: string, row: string, bay: string, cancelToken?: CancelToken): Promise<GetInventoryForBayViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/Inventory/terminal/{terminal}/row/{row}/bay/{bay}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        if (row === undefined || row === null)
            throw new Error("The parameter 'row' must be defined.");
        url_ = url_.replace("{row}", encodeURIComponent("" + row));
        if (bay === undefined || bay === null)
            throw new Error("The parameter 'bay' must be defined.");
        url_ = url_.replace("{bay}", encodeURIComponent("" + bay));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInventoryForBay(_response);
        });
    }

    protected processGetInventoryForBay(response: AxiosResponse): Promise<GetInventoryForBayViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GetInventoryForBayViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInventoryForBayViewModelApiResultResponse>(null as any);
    }

    /**
     * Validate Inventory Item
     * @param body (optional) 
     */
    validateInventory(barcode: string, body?: ValidateCommandDto | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Inventory/validate/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateInventory(_response);
        });
    }

    protected processValidateInventory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IManifestsClient {
    /**
     * Get Manifest Headers
     * @param body (optional) 
     * @return OK
     */
    manifestList(body?: LazyLoadEvent | undefined): Promise<ManifestDtoPaginatedResultApiResultResponse>;
    /**
     * Force Unload Status
     * @return OK
     */
    forceUnload(id: string): Promise<ApiResponse>;
    /**
     * Arrive manifest
     * @param body (optional) 
     * @return OK
     */
    arrive(id: string, body?: ArrivalDto | undefined): Promise<ApiResponse>;
    /**
     * Assign Pickups  to manifest
     * @param body (optional) 
     * @return OK
     */
    assignPickups(id: string, body?: AssignPickupCommandDto[] | undefined): Promise<boolean>;
    /**
     * Assign pros to manifest
     * @param body (optional) 
     * @return OK
     */
    assignPros(id: string, body?: AssignProToManifestCommandDto[] | undefined): Promise<boolean>;
    /**
     * Update Carrier
     * @param body (optional) 
     * @return OK
     */
    updateCarrier(id: string, body?: UpdateCarrierCommandDto | undefined): Promise<ApiResponse>;
    /**
     * Close manifest
     * @return OK
     */
    close(id: string): Promise<ApiResponse>;
    /**
     * Close Inbound Manifest
     * @return OK
     */
    closeInbound(id: string): Promise<ApiResponse>;
    /**
     * Depart manifest
     * @param body (optional) 
     * @return OK
     */
    depart(id: string, body?: DepartDto | undefined): Promise<ApiResponse>;
    /**
     * Plan inbound dispositions
     * @param body (optional) 
     * @return OK
     */
    inboundPlan(id: string, body?: InboundHandling[] | undefined): Promise<ApiResponse>;
    /**
     * Get Manifest Status Logs
     * @param body (optional) 
     * @return OK
     */
    manifestLogs(id: string, body?: LazyLoadEvent | undefined): Promise<ManifestStatusLogPaginatedResultApiResultResponse>;
    /**
     * Assign pros to linehaul stop
     * @param body (optional) 
     * @return OK
     */
    assignProsToLineHaulStop(id: string, body?: AssignProsToLinehaulStopCommandDto | undefined): Promise<boolean>;
    /**
     * Set default locations for a pro
     * @param body (optional) 
     * @return OK
     */
    setDefaultLocationForPro(id: string, body?: SetDefaultLocationsForProCommandDto | undefined): Promise<ApiResponse>;
    /**
     * Pull item from manifest
     * @return OK
     */
    pullItem(id: string, barcode: string, location: string): Promise<CommandResult>;
    /**
     * Pull pros from manifest
     * @param body (optional) 
     * @return OK
     */
    pullPro(id: string, proNumber: string, body?: PullLocationDTO | undefined): Promise<CommandResult>;
    /**
     * Release manifest
     * @param body (optional) 
     * @return OK
     */
    release(id: string, body?: ReleaseCommandDto | undefined): Promise<ApiResponse>;
    /**
     * Release Outbound manifest
     * @param body (optional) 
     * @return OK
     */
    releaseOutbound(id: string, body?: ReleaseOutboundDto | undefined): Promise<ApiResponse>;
    /**
     * Reopen manifest
     * @param body (optional) 
     * @return OK
     */
    reopen(id: string, body?: ReopenCommand | undefined): Promise<ApiResponse>;
    /**
     * Return item from manifest
     * @param body (optional) 
     * @return OK
     */
    returnItem(id: string, barcode: string, location: string, body?: ReturnItemCommand | undefined): Promise<CommandResult>;
    /**
     * Return a pro to dock
     * @param body (optional) 
     * @return OK
     */
    returnPro(id: string, proNumber: string, body?: ReturnProToDockCommand | undefined): Promise<CommandResult>;
    /**
     * Reorder Stops
     * @param body (optional) 
     * @return OK
     */
    reorderStops(id: string, body?: ReorderStopsCommandDto | undefined): Promise<ApiResponse>;
    /**
     * Synch manifest queue
     * @return OK
     */
    synch(id: string): Promise<ApiResponse>;
    /**
     * Update Tag
     * @param body (optional) 
     * @return OK
     */
    updateTag(id: string, body?: UpdateTagCommandDto | undefined): Promise<ApiResponse>;
    /**
     * Update Destination termina;
     * @param body (optional) 
     * @return OK
     */
    updateDestinationTerminal(id: string, body?: UpdateDestinationTerminalCommandDto | undefined): Promise<ApiResponse>;
    /**
     * Update Origin termina;
     * @param body (optional) 
     * @return OK
     */
    updateOriginTerminal(id: string, body?: UpdateOriginTerminalCommandDto | undefined): Promise<ApiResponse>;
    /**
     * Assign Trailer
     * @param body (optional) 
     * @return OK
     */
    assignTrailer(id: string, body?: AssignTrailerCommand | undefined): Promise<ApiResponse>;
    /**
     * Unassign pros from manifest
     * @param body (optional) 
     * @return OK
     */
    unassignPros(id: string, body?: UnassignedProFromManifestCommandDto[] | undefined): Promise<CommandResult>;
    /**
     * Undepart manifest
     * @param body (optional) 
     * @return OK
     */
    undepart(id: string, body?: UndepartCommand | undefined): Promise<ApiResponse>;
    /**
     * Update Xref
     * @param body (optional) 
     * @return OK
     */
    updateXref(id: string, body?: UpdateXrefCommandDto | undefined): Promise<ApiResponse>;
    /**
     * Get Manifest
     * @return OK
     */
    manifestGet(manifestId: string): Promise<ManifestFullDetailDtoApiResultResponse>;
    /**
     * Get Manifest At Date
     * @return OK
     */
    manifestGetAtDate(manifestId: string, date: Date): Promise<ManifestFullDetailDtoApiResultResponse>;
    /**
     * Get Manifest At Version
     * @return OK
     */
    manifestGetAtVersion(manifestId: string, version: number): Promise<ManifestFullDetailWithQueueDtoApiResultResponse>;
    /**
     * Created Delivery Manifest
     * @param body (optional) 
     * @return OK
     */
    newDeliveryManifest(body?: CreateDeliveryManifestDto | undefined): Promise<ApiResponse>;
    /**
     * Force Manifest Status
     * @return OK
     */
    forceManifestStatus(id: string, status: string): Promise<ApiResponse>;
    /**
     * Get Inventory
     * @param body (optional) 
     * @return OK
     */
    inventory(body?: LazyLoadEvent | undefined): Promise<InventoryDtoPaginatedResultApiResultResponse>;
    /**
     * Created Linehaul Manifest
     * @param body (optional) 
     * @return OK
     */
    newLinehaulManifest(body?: CreateLinehaulManifestDto | undefined): Promise<ApiResponse>;
    /**
     * Generates a new Manifest IDr
     * @return OK
     */
    generateManifestId(): Promise<ManifestNumberDtoApiResultResponse>;
    /**
     * Get Outbound Manifests For Terminal
     * @return OK
     */
    getOutboundByTerminal(terminal: string): Promise<ManifestDtoListApiResultResponse>;
    /**
     * Created Pickup Manifest
     * @param body (optional) 
     * @return OK
     */
    newPickupManifest(body?: CreatePickupManifestDto | undefined): Promise<ApiResponse>;
    /**
     * Get Manifest status list
     * @return OK
     */
    manifestStatusesGet(): Promise<ManifestStatusListApiResultResponse>;
}

export class ManifestsClient extends ApiBase implements IManifestsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get Manifest Headers
     * @param body (optional) 
     * @return OK
     */
    manifestList(body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ManifestDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestList(_response);
        });
    }

    protected processManifestList(response: AxiosResponse): Promise<ManifestDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Force Unload Status
     * @return OK
     */
    forceUnload(id: string, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForceUnload(_response);
        });
    }

    protected processForceUnload(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Arrive manifest
     * @param body (optional) 
     * @return OK
     */
    arrive(id: string, body?: ArrivalDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/arrive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArrive(_response);
        });
    }

    protected processArrive(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Assign Pickups  to manifest
     * @param body (optional) 
     * @return OK
     */
    assignPickups(id: string, body?: AssignPickupCommandDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/assignpickups";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignPickups(_response);
        });
    }

    protected processAssignPickups(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            // Handle both stringified JSON and raw boolean/non-JSON literals (e.g., True/False)
            if (typeof _responseText === 'string') {
                try {
                    result200 = JSON.parse(_responseText);
                } catch (err) {
                    const v = _responseText.trim().toLowerCase();
                    if (v === 'true') result200 = true;
                    else if (v === 'false') result200 = false;
                    else result200 = _responseText;
                }
            } else {
                result200 = _responseText;
            }
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Assign pros to manifest
     * @param body (optional) 
     * @return OK
     */
    assignPros(id: string, body?: AssignProToManifestCommandDto[] | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/assignpros";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignPros(_response);
        });
    }

    protected processAssignPros(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            // Handle both stringified JSON and raw boolean/non-JSON literals (e.g., True/False)
            if (typeof _responseText === 'string') {
                try {
                    result200 = JSON.parse(_responseText);
                } catch (err) {
                    const v = _responseText.trim().toLowerCase();
                    if (v === 'true') result200 = true;
                    else if (v === 'false') result200 = false;
                    else result200 = _responseText;
                }
            } else {
                result200 = _responseText;
            }
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Carrier
     * @param body (optional) 
     * @return OK
     */
    updateCarrier(id: string, body?: UpdateCarrierCommandDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/carrier";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCarrier(_response);
        });
    }

    protected processUpdateCarrier(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Close manifest
     * @return OK
     */
    close(id: string, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/close";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClose(_response);
        });
    }

    protected processClose(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Close Inbound Manifest
     * @return OK
     */
    closeInbound(id: string, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/closeinbound";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseInbound(_response);
        });
    }

    protected processCloseInbound(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Depart manifest
     * @param body (optional) 
     * @return OK
     */
    depart(id: string, body?: DepartDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/depart";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDepart(_response);
        });
    }

    protected processDepart(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Plan inbound dispositions
     * @param body (optional) 
     * @return OK
     */
    inboundPlan(id: string, body?: InboundHandling[] | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/inbound/plan";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInboundPlan(_response);
        });
    }

    protected processInboundPlan(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Get Manifest Status Logs
     * @param body (optional) 
     * @return OK
     */
    manifestLogs(id: string, body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ManifestStatusLogPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/logs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestLogs(_response);
        });
    }

    protected processManifestLogs(response: AxiosResponse): Promise<ManifestStatusLogPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestStatusLogPaginatedResultApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestStatusLogPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Assign pros to linehaul stop
     * @param body (optional) 
     * @return OK
     */
    assignProsToLineHaulStop(id: string, body?: AssignProsToLinehaulStopCommandDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/pro/assignlinehaulstop";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignProsToLineHaulStop(_response);
        });
    }

    protected processAssignProsToLineHaulStop(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Set default locations for a pro
     * @param body (optional) 
     * @return OK
     */
    setDefaultLocationForPro(id: string, body?: SetDefaultLocationsForProCommandDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/pro/locations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDefaultLocationForPro(_response);
        });
    }

    protected processSetDefaultLocationForPro(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Pull item from manifest
     * @return OK
     */
    pullItem(id: string, barcode: string, location: string, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/pull/{barcode}/locate/{location}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        if (location === undefined || location === null)
            throw new Error("The parameter 'location' must be defined.");
        url_ = url_.replace("{location}", encodeURIComponent("" + location));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPullItem(_response);
        });
    }

    protected processPullItem(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Pull pros from manifest
     * @param body (optional) 
     * @return OK
     */
    pullPro(id: string, proNumber: string, body?: PullLocationDTO | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/pull/{proNumber}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPullPro(_response);
        });
    }

    protected processPullPro(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Release manifest
     * @param body (optional) 
     * @return OK
     */
    release(id: string, body?: ReleaseCommandDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/release";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRelease(_response);
        });
    }

    protected processRelease(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Release Outbound manifest
     * @param body (optional) 
     * @return OK
     */
    releaseOutbound(id: string, body?: ReleaseOutboundDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/releaseoutbound";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReleaseOutbound(_response);
        });
    }

    protected processReleaseOutbound(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Reopen manifest
     * @param body (optional) 
     * @return OK
     */
    reopen(id: string, body?: ReopenCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/reopen";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReopen(_response);
        });
    }

    protected processReopen(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Return item from manifest
     * @param body (optional) 
     * @return OK
     */
    returnItem(id: string, barcode: string, location: string, body?: ReturnItemCommand | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/return/{barcode}/locate/{location}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        if (location === undefined || location === null)
            throw new Error("The parameter 'location' must be defined.");
        url_ = url_.replace("{location}", encodeURIComponent("" + location));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReturnItem(_response);
        });
    }

    protected processReturnItem(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Return a pro to dock
     * @param body (optional) 
     * @return OK
     */
    returnPro(id: string, proNumber: string, body?: ReturnProToDockCommand | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/return/{proNumber}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReturnPro(_response);
        });
    }

    protected processReturnPro(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Reorder Stops
     * @param body (optional) 
     * @return OK
     */
    reorderStops(id: string, body?: ReorderStopsCommandDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/stops/reorder";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReorderStops(_response);
        });
    }

    protected processReorderStops(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Synch manifest queue
     * @return OK
     */
    synch(id: string, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/synch";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSynch(_response);
        });
    }

    protected processSynch(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Update Tag
     * @param body (optional) 
     * @return OK
     */
    updateTag(id: string, body?: UpdateTagCommandDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/tag";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTag(_response);
        });
    }

    protected processUpdateTag(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Update Destination termina;
     * @param body (optional) 
     * @return OK
     */
    updateDestinationTerminal(id: string, body?: UpdateDestinationTerminalCommandDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/terminal/destination";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDestinationTerminal(_response);
        });
    }

    protected processUpdateDestinationTerminal(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Update Origin termina;
     * @param body (optional) 
     * @return OK
     */
    updateOriginTerminal(id: string, body?: UpdateOriginTerminalCommandDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/terminal/origin";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOriginTerminal(_response);
        });
    }

    protected processUpdateOriginTerminal(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Assign Trailer
     * @param body (optional) 
     * @return OK
     */
    assignTrailer(id: string, body?: AssignTrailerCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/trailer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignTrailer(_response);
        });
    }

    protected processAssignTrailer(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Unassign pros from manifest
     * @param body (optional) 
     * @return OK
     */
    unassignPros(id: string, body?: UnassignedProFromManifestCommandDto[] | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/unassignpros";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnassignPros(_response);
        });
    }

    protected processUnassignPros(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Undepart manifest
     * @param body (optional) 
     * @return OK
     */
    undepart(id: string, body?: UndepartCommand | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/undepart";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUndepart(_response);
        });
    }

    protected processUndepart(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Update Xref
     * @param body (optional) 
     * @return OK
     */
    updateXref(id: string, body?: UpdateXrefCommandDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{id}/xref";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateXref(_response);
        });
    }

    protected processUpdateXref(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Get Manifest
     * @return OK
     */
    manifestGet(manifestId: string, cancelToken?: CancelToken): Promise<ManifestFullDetailDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestGet(_response);
        });
    }

    protected processManifestGet(response: AxiosResponse): Promise<ManifestFullDetailDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestFullDetailDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestFullDetailDtoApiResultResponse>(null as any);
    }

    /**
     * Get Manifest At Date
     * @return OK
     */
    manifestGetAtDate(manifestId: string, date: Date, cancelToken?: CancelToken): Promise<ManifestFullDetailDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{manifestId}/date/{date}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestGetAtDate(_response);
        });
    }

    protected processManifestGetAtDate(response: AxiosResponse): Promise<ManifestFullDetailDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestFullDetailDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestFullDetailDtoApiResultResponse>(null as any);
    }

    /**
     * Get Manifest At Version
     * @return OK
     */
    manifestGetAtVersion(manifestId: string, version: number, cancelToken?: CancelToken): Promise<ManifestFullDetailWithQueueDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests/{manifestId}/version/{version}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestGetAtVersion(_response);
        });
    }

    protected processManifestGetAtVersion(response: AxiosResponse): Promise<ManifestFullDetailWithQueueDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestFullDetailWithQueueDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestFullDetailWithQueueDtoApiResultResponse>(null as any);
    }

    /**
     * Created Delivery Manifest
     * @param body (optional) 
     * @return OK
     */
    newDeliveryManifest(body?: CreateDeliveryManifestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/delivery/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewDeliveryManifest(_response);
        });
    }

    protected processNewDeliveryManifest(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Force Manifest Status
     * @return OK
     */
    forceManifestStatus(id: string, status: string, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/force/{id}/status/{status}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForceManifestStatus(_response);
        });
    }

    protected processForceManifestStatus(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Get Inventory
     * @param body (optional) 
     * @return OK
     */
    inventory(body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<InventoryDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests/inventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInventory(_response);
        });
    }

    protected processInventory(response: AxiosResponse): Promise<InventoryDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<InventoryDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InventoryDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Created Linehaul Manifest
     * @param body (optional) 
     * @return OK
     */
    newLinehaulManifest(body?: CreateLinehaulManifestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/linehaul/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewLinehaulManifest(_response);
        });
    }

    protected processNewLinehaulManifest(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Generates a new Manifest IDr
     * @return OK
     */
    generateManifestId( cancelToken?: CancelToken): Promise<ManifestNumberDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests/manifest/newid";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateManifestId(_response);
        });
    }

    protected processGenerateManifestId(response: AxiosResponse): Promise<ManifestNumberDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestNumberDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestNumberDtoApiResultResponse>(null as any);
    }

    /**
     * Get Outbound Manifests For Terminal
     * @return OK
     */
    getOutboundByTerminal(terminal: string, cancelToken?: CancelToken): Promise<ManifestDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests/outbound/{terminal}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOutboundByTerminal(_response);
        });
    }

    protected processGetOutboundByTerminal(response: AxiosResponse): Promise<ManifestDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestDtoListApiResultResponse>(null as any);
    }

    /**
     * Created Pickup Manifest
     * @param body (optional) 
     * @return OK
     */
    newPickupManifest(body?: CreatePickupManifestDto | undefined, cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Manifests/pickup/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewPickupManifest(_response);
        });
    }

    protected processNewPickupManifest(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Get Manifest status list
     * @return OK
     */
    manifestStatusesGet( cancelToken?: CancelToken): Promise<ManifestStatusListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Manifests/status/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processManifestStatusesGet(_response);
        });
    }

    protected processManifestStatusesGet(response: AxiosResponse): Promise<ManifestStatusListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ManifestStatusListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ManifestStatusListApiResultResponse>(null as any);
    }
}

export interface IOrphanClient {
    /**
     * Create Orphan
     * @param body (optional) 
     * @return OK
     */
    createOrphan(body?: CreateBarcodeCommand | undefined): Promise<CommandResult>;
    /**
     * Assign Orphan to Pro
     * @param body (optional) 
     * @return OK
     */
    assignOrphan(barcode: string, body?: AssignOrphan | undefined): Promise<CommandResult>;
    /**
     * Confirm Orphan Assignment
     * @param body (optional) 
     * @return OK
     */
    confirmOrphanAssignment(barcode: string, body?: ConfirmOrphanAssignment | undefined): Promise<CommandResult>;
    /**
     * Assign Location to Orphan
     * @param body (optional) 
     * @return OK
     */
    assignOrphanLocation(barcode: string, body?: AssignLocation | undefined): Promise<CommandResult>;
    /**
     * Update Orphan Metadata
     * @param body (optional) 
     * @return OK
     */
    updateOrphanMetadata(barcode: string, body?: UpdateMetadata | undefined): Promise<CommandResult>;
    /**
     * Append Note to Orphan
     * @param body (optional) 
     * @return OK
     */
    appendOrphanNote(barcode: string, body?: AppendNote | undefined): Promise<CommandResult>;
    /**
     * Get orphan by barcode
     * @return OK
     */
    barcode(barcode: string): Promise<OrphanDtoApiResultResponse>;
    /**
     * Get next available barcode
     * @return Successfully retrieved next barcode
     */
    nextBarcode(): Promise<ApiResponse>;
    /**
     * Get orphans by terminal
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    terminal(terminalId: string, pageNumber?: number | undefined, pageSize?: number | undefined): Promise<OrphanDtoPaginatedResultApiResultResponse>;
}

export class OrphanClient extends ApiBase implements IOrphanClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create Orphan
     * @param body (optional) 
     * @return OK
     */
    createOrphan(body?: CreateBarcodeCommand | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Orphan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrphan(_response);
        });
    }

    protected processCreateOrphan(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Assign Orphan to Pro
     * @param body (optional) 
     * @return OK
     */
    assignOrphan(barcode: string, body?: AssignOrphan | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Orphan/{barcode}/assign";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignOrphan(_response);
        });
    }

    protected processAssignOrphan(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Confirm Orphan Assignment
     * @param body (optional) 
     * @return OK
     */
    confirmOrphanAssignment(barcode: string, body?: ConfirmOrphanAssignment | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Orphan/{barcode}/confirm";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmOrphanAssignment(_response);
        });
    }

    protected processConfirmOrphanAssignment(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Assign Location to Orphan
     * @param body (optional) 
     * @return OK
     */
    assignOrphanLocation(barcode: string, body?: AssignLocation | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Orphan/{barcode}/location";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignOrphanLocation(_response);
        });
    }

    protected processAssignOrphanLocation(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Update Orphan Metadata
     * @param body (optional) 
     * @return OK
     */
    updateOrphanMetadata(barcode: string, body?: UpdateMetadata | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Orphan/{barcode}/metadata";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrphanMetadata(_response);
        });
    }

    protected processUpdateOrphanMetadata(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Append Note to Orphan
     * @param body (optional) 
     * @return OK
     */
    appendOrphanNote(barcode: string, body?: AppendNote | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Orphan/{barcode}/notes";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAppendOrphanNote(_response);
        });
    }

    protected processAppendOrphanNote(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Get orphan by barcode
     * @return OK
     */
    barcode(barcode: string, cancelToken?: CancelToken): Promise<OrphanDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Orphan/barcode/{barcode}";
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBarcode(_response);
        });
    }

    protected processBarcode(response: AxiosResponse): Promise<OrphanDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrphanDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Orphan not found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrphanDtoApiResultResponse>(null as any);
    }

    /**
     * Get next available barcode
     * @return Successfully retrieved next barcode
     */
    nextBarcode( cancelToken?: CancelToken): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/api/Orphan/next-barcode";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNextBarcode(_response);
        });
    }

    protected processNextBarcode(response: AxiosResponse): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal server error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Get orphans by terminal
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    terminal(terminalId: string, pageNumber?: number | undefined, pageSize?: number | undefined, cancelToken?: CancelToken): Promise<OrphanDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Orphan/terminal/{terminalId}?";
        if (terminalId === undefined || terminalId === null)
            throw new Error("The parameter 'terminalId' must be defined.");
        url_ = url_.replace("{terminalId}", encodeURIComponent("" + terminalId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTerminal(_response);
        });
    }

    protected processTerminal(response: AxiosResponse): Promise<OrphanDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrphanDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Invalid request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrphanDtoPaginatedResultApiResultResponse>(null as any);
    }
}

export interface IPostal_CodesClient {
    /**
     * Get List of Postal Codes
     * @return OK
     */
    postalCodeList(): Promise<PostalCodeDtoListApiResultResponse>;
    /**
     * Get Postal Code Info
     * @return OK
     */
    postalCodeGet(postalCode: string): Promise<PostalCodeShortDtoApiResultResponse>;
    /**
     * Get Postal Codes for a State
     * @return OK
     */
    postalCodeGetByState(state: string): Promise<PostalCodeShortListDtoApiResultResponse>;
    /**
     * Get Postal Codes for a State
     * @return OK
     */
    postalCodeGetByStateAbbrev(abbreviation: string): Promise<PostalCodeShortListDtoApiResultResponse>;
    /**
     * Get List of Available Postal Code Prefixes
     * @return OK
     */
    postalCodeLaneAvailablePrefixList(): Promise<LaneAvailablePrefixesViewModelApiResultResponse>;
    /**
     * Get List of Postal Code Prefixes
     * @return OK
     */
    postalCodePrefixList(): Promise<PostalCodePrefixListViewModelApiResultResponse>;
}

export class Postal_CodesClient extends ApiBase implements IPostal_CodesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get List of Postal Codes
     * @return OK
     */
    postalCodeList( cancelToken?: CancelToken): Promise<PostalCodeDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/PostalCodes/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostalCodeList(_response);
        });
    }

    protected processPostalCodeList(response: AxiosResponse): Promise<PostalCodeDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostalCodeDtoListApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostalCodeDtoListApiResultResponse>(null as any);
    }

    /**
     * Get Postal Code Info
     * @return OK
     */
    postalCodeGet(postalCode: string, cancelToken?: CancelToken): Promise<PostalCodeShortDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/PostalCodes/Get/{postalCode}";
        if (postalCode === undefined || postalCode === null)
            throw new Error("The parameter 'postalCode' must be defined.");
        url_ = url_.replace("{postalCode}", encodeURIComponent("" + postalCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostalCodeGet(_response);
        });
    }

    protected processPostalCodeGet(response: AxiosResponse): Promise<PostalCodeShortDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostalCodeShortDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostalCodeShortDtoApiResultResponse>(null as any);
    }

    /**
     * Get Postal Codes for a State
     * @return OK
     */
    postalCodeGetByState(state: string, cancelToken?: CancelToken): Promise<PostalCodeShortListDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/PostalCodes/GetByState/{state}";
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined.");
        url_ = url_.replace("{state}", encodeURIComponent("" + state));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostalCodeGetByState(_response);
        });
    }

    protected processPostalCodeGetByState(response: AxiosResponse): Promise<PostalCodeShortListDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostalCodeShortListDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostalCodeShortListDtoApiResultResponse>(null as any);
    }

    /**
     * Get Postal Codes for a State
     * @return OK
     */
    postalCodeGetByStateAbbrev(abbreviation: string, cancelToken?: CancelToken): Promise<PostalCodeShortListDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/PostalCodes/GetByStateAbbrev/{abbreviation}";
        if (abbreviation === undefined || abbreviation === null)
            throw new Error("The parameter 'abbreviation' must be defined.");
        url_ = url_.replace("{abbreviation}", encodeURIComponent("" + abbreviation));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostalCodeGetByStateAbbrev(_response);
        });
    }

    protected processPostalCodeGetByStateAbbrev(response: AxiosResponse): Promise<PostalCodeShortListDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostalCodeShortListDtoApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostalCodeShortListDtoApiResultResponse>(null as any);
    }

    /**
     * Get List of Available Postal Code Prefixes
     * @return OK
     */
    postalCodeLaneAvailablePrefixList( cancelToken?: CancelToken): Promise<LaneAvailablePrefixesViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/PostalCodes/LaneAvailablePrefixes/available";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostalCodeLaneAvailablePrefixList(_response);
        });
    }

    protected processPostalCodeLaneAvailablePrefixList(response: AxiosResponse): Promise<LaneAvailablePrefixesViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LaneAvailablePrefixesViewModelApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LaneAvailablePrefixesViewModelApiResultResponse>(null as any);
    }

    /**
     * Get List of Postal Code Prefixes
     * @return OK
     */
    postalCodePrefixList( cancelToken?: CancelToken): Promise<PostalCodePrefixListViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/PostalCodes/Prefixes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostalCodePrefixList(_response);
        });
    }

    protected processPostalCodePrefixList(response: AxiosResponse): Promise<PostalCodePrefixListViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PostalCodePrefixListViewModelApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostalCodePrefixListViewModelApiResultResponse>(null as any);
    }
}

export interface IProClient {
    /**
     * Get Active Pro Headers
     * @param body (optional) 
     * @return OK
     */
    activeProFilteredList(body?: LazyLoadEvent | undefined): Promise<ProDtoPaginatedResultApiResultResponse>;
    /**
     * Add Delivery Note
     * @param body (optional) 
     * @return OK
     */
    proAddDeliveryNote(proNumber: string, body?: DeliveryNoteDto | undefined): Promise<boolean>;
    /**
     * Archive Pro
     * @return OK
     */
    archivePro(proNumber: string): Promise<boolean>;
    /**
     * Deliver Pro
     * @param body (optional) 
     * @return OK
     */
    deliverPro(proNumber: string, body?: DeliverProCommand | undefined): Promise<boolean>;
    /**
     * Retrieves the list of delivery pros available for assignment at a terminal.
     * @param terminal The terminal identifier.
     * @param body (optional) Lazy load event containing options for pagination and sorting. The filter options available for this endpoint are:
     * @return OK
     */
    availableDeliveryPros(terminal: string, body?: LazyLoadEvent | undefined): Promise<ProDtoPaginatedResultApiResultResponse>;
    /**
     * @param terminal 3 letter terminal code
     * @return OK
     */
    findProsWithIssues(terminal: string): Promise<ProWithIssuesResultListApiResultResponse>;
    /**
     * Generate Pro Number
     * @param billType Bill Type
     * @return OK
     */
    proGenerateProNumber(billType: BillTypeEnum): Promise<ProNumberDtoApiResultResponse>;
    /**
     * Get Pro
     * @param showDeactivatedTrackingUnits When true, includes deactivated tracking units (matches PRO detail Lineitems / "Deactivated?" column).
     * @return OK
     */
    proGet(proNumber: string, showDeactivatedTrackingUnits?: boolean | undefined, cancelToken?: CancelToken): Promise<ProDtoApiResultResponse>;
    /**
     * Get Pro status list
     * @return OK
     */
    proStatusesGet(): Promise<ProStatusListApiResultResponse>;
    /**
     * Get Available Linehaul Pros
     * @param body (optional) 
     * @return OK
     */
    availableLinehaulPros(terminal: string, body?: LazyLoadEvent | undefined): Promise<ProDtoPaginatedResultApiResultResponse>;
    /**
     * Get Pro Headers
     * @param page (optional) Page number ti skip to.
     * @param size (optional) Number of results to return per page.
     * @return OK
     */
    proList(page?: number | undefined, size?: number | undefined): Promise<ProDtoPaginatedResultApiResultResponse>;
    /**
     * Get Pro Headers
     * @param body (optional) 
     * @return OK
     */
    proFilteredList(body?: LazyLoadEvent | undefined): Promise<ProDtoPaginatedResultApiResultResponse>;
    /**
     * Get Filtered Pro Headers
     * @param start (optional) 
     * @param end (optional) 
     * @return OK
     */
    proListByDateRange(start?: Date | undefined, end?: Date | undefined): Promise<ListProsByDateRangeViewModelApiResultResponse>;
    /**
     * Get Available Pickup Pros
     * @param body (optional) 
     * @return OK
     */
    availablePickupPros(trailer: string, body?: LazyLoadEvent | undefined): Promise<ProDtoPaginatedResultApiResultResponse>;
    /**
     * Get Previous Status for a Pro
     * @return OK
     */
    proGetPreviousStatus(proNumber: string): Promise<PreviousStatusViewModelApiResultResponse>;
    /**
     * Get Pro Headers
     * @param body (optional) 
     * @return OK
     */
    proListFromProNumbers(body?: string[] | undefined): Promise<ProDtoListApiResultResponse>;
    /**
     * Get Pro Status Logs
     * @param body (optional) 
     * @return OK
     */
    proLogs(id: string, body?: LazyLoadEvent | undefined): Promise<ProStatusLogPaginatedResultApiResultResponse>;
    /**
     * Update tracking units pack type
     * @param body (optional) 
     * @return OK
     */
    proUpdatePackTypeForTrackingUnit(proNumber: string, body?: UpdatePackTypeForTrackingUnitCommandDto | undefined): Promise<boolean>;
    /**
     * Refresh Lane
     * @return OK
     */
    refeshLane(proNumber: string): Promise<boolean>;
    /**
     * Relocate Pro
     * @param body (optional) 
     * @return OK
     */
    relocatePro(body?: RelocateProCommandDto | undefined): Promise<boolean>;
    /**
     * Schedule Appointment
     * @param body (optional) 
     * @return OK
     */
    proScheduleAppointment(proNumber: string, body?: AppointmentDto | undefined): Promise<boolean>;
    /**
     * Schedule Pickup
     * @param body (optional) 
     * @return OK
     */
    schedulePickup(proNumber: string, body?: PickupDto | undefined): Promise<boolean>;
    /**
     * Get Pro Segments
     * @return OK
     */
    proSegments(proNumber: string): Promise<ProSegmentsViewModelListApiResultResponse>;
    /**
     * Split Pro
     * @param body (optional) 
     * @return OK
     */
    splitPro(proNumber: string, body?: SplitProCommand | undefined): Promise<boolean>;
    /**
     * Import Pro
     * @param body (optional) 
     * @return OK
     */
    proTmsImport(body?: ImportProDto | undefined): Promise<CommandResult>;
    /**
     * Undeliver Pro
     * @param body (optional) 
     * @return OK
     */
    undeliverPro(proNumber: string, body?: UndeliverProCommand | undefined): Promise<boolean>;
    /**
     * Update Active Terminal
     * @param body (optional) 
     * @return OK
     */
    proUpdateActiveTerminal(body?: ProTerminalUpdateDto | undefined): Promise<boolean>;
    /**
     * Update Bill To Party
     * @param body (optional) 
     * @return OK
     */
    proUpdateBillToParty(proNumber: string, body?: BillToPartyDto | undefined): Promise<boolean>;
    /**
     * Update Bill Type
     * @param billType Bill Type
     * @return OK
     */
    proUpdateBillType(proNumber: string, billType: BillTypeEnum): Promise<boolean>;
    /**
     * Update Carrier Consignee
     * @param body (optional) 
     * @return OK
     */
    proUpdateCarrierConsignee(proNumber: string, body?: CarrierConsigneeDto | undefined): Promise<boolean>;
    /**
     * Update Destination Terminal
     * @param body (optional) 
     * @return OK
     */
    proUpdateDestinationTerminal(body?: ProTerminalUpdateDto | undefined): Promise<boolean>;
    /**
     * Update Origin Terminal
     * @param body (optional) 
     * @return OK
     */
    proUpdateOriginTerminal(body?: ProTerminalUpdateDto | undefined): Promise<boolean>;
    /**
     * Update Pay Terms
     * @return OK
     */
    proUpdatePayTerms(proNumber: string, payTerms: string): Promise<boolean>;
    /**
     * Update Shipper
     * @param body (optional) 
     * @return OK
     */
    proUpdateShipper(proNumber: string, body?: ShipperDto | undefined): Promise<boolean>;
    /**
     * Update Shipper Consignee
     * @param body (optional) 
     * @return OK
     */
    proUpdateShipperConsignee(proNumber: string, body?: ShipperConsigneeDto | undefined): Promise<boolean>;
    /**
     * Void Pro
     * @param body (optional) 
     * @return OK
     */
    voidPro(proNumber: string, body?: VoidProCommand | undefined): Promise<boolean>;
    /**
     * Unvoid Pro
     * @param body (optional)
     * @return OK
     */
    unvoidPro(proNumber: string, body?: UnvoidProCommand | undefined): Promise<boolean>;
}

export class ProClient extends ApiBase implements IProClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get Active Pro Headers
     * @param body (optional) 
     * @return OK
     */
    activeProFilteredList(body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ProDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/Active";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActiveProFilteredList(_response);
        });
    }

    protected processActiveProFilteredList(response: AxiosResponse): Promise<ProDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Add Delivery Note
     * @param body (optional) 
     * @return OK
     */
    proAddDeliveryNote(proNumber: string, body?: DeliveryNoteDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/AddDeliveryNote/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProAddDeliveryNote(_response);
        });
    }

    protected processProAddDeliveryNote(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Archive Pro
     * @return OK
     */
    archivePro(proNumber: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/ArchivePro/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchivePro(_response);
        });
    }

    protected processArchivePro(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Deliver Pro
     * @param body (optional) 
     * @return OK
     */
    deliverPro(proNumber: string, body?: DeliverProCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/DeliverPro/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeliverPro(_response);
        });
    }

    protected processDeliverPro(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Retrieves the list of delivery pros available for assignment at a terminal.
     * @param terminal The terminal identifier.
     * @param body (optional) Lazy load event containing options for pagination and sorting. The filter options available for this endpoint are:
     * @return OK
     */
    availableDeliveryPros(terminal: string, body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ProDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/DeliveryPros/terminal/{terminal}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAvailableDeliveryPros(_response);
        });
    }

    protected processAvailableDeliveryPros(response: AxiosResponse): Promise<ProDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * @param terminal 3 letter terminal code
     * @return OK
     */
    findProsWithIssues(terminal: string, cancelToken?: CancelToken): Promise<ProWithIssuesResultListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/FindProsWithIssues/{terminal}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindProsWithIssues(_response);
        });
    }

    protected processFindProsWithIssues(response: AxiosResponse): Promise<ProWithIssuesResultListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProWithIssuesResultListApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProWithIssuesResultListApiResultResponse>(null as any);
    }

    /**
     * Generate Pro Number
     * @param billType Bill Type
     * @return OK
     */
    proGenerateProNumber(billType: BillTypeEnum, cancelToken?: CancelToken): Promise<ProNumberDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/GenerateProNumber/{billType}";
        if (billType === undefined || billType === null)
            throw new Error("The parameter 'billType' must be defined.");
        url_ = url_.replace("{billType}", encodeURIComponent("" + billType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProGenerateProNumber(_response);
        });
    }

    protected processProGenerateProNumber(response: AxiosResponse): Promise<ProNumberDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProNumberDtoApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProNumberDtoApiResultResponse>(null as any);
    }

    /**
     * Get Pro
     * @return OK
     */
    proGet(proNumber: string, showDeactivatedTrackingUnits?: boolean | undefined, cancelToken?: CancelToken): Promise<ProDtoApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/Get/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");
        if (showDeactivatedTrackingUnits === true) {
            url_ += "?showDeactivatedTrackingUnits=true";
        }

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProGet(_response);
        });
    }

    protected processProGet(response: AxiosResponse): Promise<ProDtoApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoApiResultResponse>(null as any);
    }

    /**
     * Get Pro status list
     * @return OK
     */
    proStatusesGet( cancelToken?: CancelToken): Promise<ProStatusListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/GetProStatuses/status/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProStatusesGet(_response);
        });
    }

    protected processProStatusesGet(response: AxiosResponse): Promise<ProStatusListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProStatusListApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProStatusListApiResultResponse>(null as any);
    }

    /**
     * Get Available Linehaul Pros
     * @param body (optional) 
     * @return OK
     */
    availableLinehaulPros(terminal: string, body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ProDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/LinehaulPros/terminal/{terminal}";
        if (terminal === undefined || terminal === null)
            throw new Error("The parameter 'terminal' must be defined.");
        url_ = url_.replace("{terminal}", encodeURIComponent("" + terminal));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAvailableLinehaulPros(_response);
        });
    }

    protected processAvailableLinehaulPros(response: AxiosResponse): Promise<ProDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Get Pro Headers
     * @param page (optional) Page number ti skip to.
     * @param size (optional) Number of results to return per page.
     * @return OK
     */
    proList(page?: number | undefined, size?: number | undefined, cancelToken?: CancelToken): Promise<ProDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/List?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProList(_response);
        });
    }

    protected processProList(response: AxiosResponse): Promise<ProDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Get Pro Headers
     * @param body (optional) 
     * @return OK
     */
    proFilteredList(body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ProDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProFilteredList(_response);
        });
    }

    protected processProFilteredList(response: AxiosResponse): Promise<ProDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Get Filtered Pro Headers
     * @param start (optional) 
     * @param end (optional) 
     * @return OK
     */
    proListByDateRange(start?: Date | undefined, end?: Date | undefined, cancelToken?: CancelToken): Promise<ListProsByDateRangeViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/ListByDateRange?";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProListByDateRange(_response);
        });
    }

    protected processProListByDateRange(response: AxiosResponse): Promise<ListProsByDateRangeViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ListProsByDateRangeViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListProsByDateRangeViewModelApiResultResponse>(null as any);
    }

    /**
     * Get Available Pickup Pros
     * @param body (optional) 
     * @return OK
     */
    availablePickupPros(trailer: string, body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ProDtoPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/PickupQueue/{trailer}";
        if (trailer === undefined || trailer === null)
            throw new Error("The parameter 'trailer' must be defined.");
        url_ = url_.replace("{trailer}", encodeURIComponent("" + trailer));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAvailablePickupPros(_response);
        });
    }

    protected processAvailablePickupPros(response: AxiosResponse): Promise<ProDtoPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Get Previous Status for a Pro
     * @return OK
     */
    proGetPreviousStatus(proNumber: string, cancelToken?: CancelToken): Promise<PreviousStatusViewModelApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/PreviousStatus/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProGetPreviousStatus(_response);
        });
    }

    protected processProGetPreviousStatus(response: AxiosResponse): Promise<PreviousStatusViewModelApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PreviousStatusViewModelApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreviousStatusViewModelApiResultResponse>(null as any);
    }

    /**
     * Get Pro Headers
     * @param body (optional) 
     * @return OK
     */
    proListFromProNumbers(body?: string[] | undefined, cancelToken?: CancelToken): Promise<ProDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/ProListFromProNumbers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProListFromProNumbers(_response);
        });
    }

    protected processProListFromProNumbers(response: AxiosResponse): Promise<ProDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoListApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoListApiResultResponse>(null as any);
    }

    /**
     * Get Pro Status Logs
     * @param body (optional) 
     * @return OK
     */
    proLogs(id: string, body?: LazyLoadEvent | undefined, cancelToken?: CancelToken): Promise<ProStatusLogPaginatedResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/ProLogs/{id}/logs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProLogs(_response);
        });
    }

    protected processProLogs(response: AxiosResponse): Promise<ProStatusLogPaginatedResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProStatusLogPaginatedResultApiResultResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProStatusLogPaginatedResultApiResultResponse>(null as any);
    }

    /**
     * Update tracking units pack type
     * @param body (optional) 
     * @return OK
     */
    proUpdatePackTypeForTrackingUnit(proNumber: string, body?: UpdatePackTypeForTrackingUnitCommandDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/ProUpdatePackTypeForTrackingUnit/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdatePackTypeForTrackingUnit(_response);
        });
    }

    protected processProUpdatePackTypeForTrackingUnit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Refresh Lane
     * @return OK
     */
    refeshLane(proNumber: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/RefreshLane/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefeshLane(_response);
        });
    }

    protected processRefeshLane(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Relocate Pro
     * @param body (optional) 
     * @return OK
     */
    relocatePro(body?: RelocateProCommandDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/RelocatePro";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRelocatePro(_response);
        });
    }

    protected processRelocatePro(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Schedule Appointment
     * @param body (optional) 
     * @return OK
     */
    proScheduleAppointment(proNumber: string, body?: AppointmentDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/ScheduleAppointment/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProScheduleAppointment(_response);
        });
    }

    protected processProScheduleAppointment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Schedule Pickup
     * @param body (optional) 
     * @return OK
     */
    schedulePickup(proNumber: string, body?: PickupDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/SchedulePickup/{proNumber}/pickup/schedule";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchedulePickup(_response);
        });
    }

    protected processSchedulePickup(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Get Pro Segments
     * @return OK
     */
    proSegments(proNumber: string, cancelToken?: CancelToken): Promise<ProSegmentsViewModelListApiResultResponse> {
        let url_ = this.baseUrl + "/api/Pro/Segments/{proNumber}/segments";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProSegments(_response);
        });
    }

    protected processProSegments(response: AxiosResponse): Promise<ProSegmentsViewModelListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProSegmentsViewModelListApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProSegmentsViewModelListApiResultResponse>(null as any);
    }

    /**
     * Split Pro
     * @param body (optional) 
     * @return OK
     */
    splitPro(proNumber: string, body?: SplitProCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/SplitPro/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSplitPro(_response);
        });
    }

    protected processSplitPro(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Import Pro
     * @param body (optional) 
     * @return OK
     */
    proTmsImport(body?: ImportProDto | undefined, cancelToken?: CancelToken): Promise<CommandResult> {
        let url_ = this.baseUrl + "/api/Pro/TmsImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProTmsImport(_response);
        });
    }

    protected processProTmsImport(response: AxiosResponse): Promise<CommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommandResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommandResult>(null as any);
    }

    /**
     * Undeliver Pro
     * @param body (optional) 
     * @return OK
     */
    undeliverPro(proNumber: string, body?: UndeliverProCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UndeliverPro/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUndeliverPro(_response);
        });
    }

    protected processUndeliverPro(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Active Terminal
     * @param body (optional) 
     * @return OK
     */
    proUpdateActiveTerminal(body?: ProTerminalUpdateDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdateActiveTerminal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdateActiveTerminal(_response);
        });
    }

    protected processProUpdateActiveTerminal(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Bill To Party
     * @param body (optional) 
     * @return OK
     */
    proUpdateBillToParty(proNumber: string, body?: BillToPartyDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdateBillToParty/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdateBillToParty(_response);
        });
    }

    protected processProUpdateBillToParty(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Bill Type
     * @param billType Bill Type
     * @return OK
     */
    proUpdateBillType(proNumber: string, billType: BillTypeEnum, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdateBillType/{proNumber}/{billType}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        if (billType === undefined || billType === null)
            throw new Error("The parameter 'billType' must be defined.");
        url_ = url_.replace("{billType}", encodeURIComponent("" + billType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdateBillType(_response);
        });
    }

    protected processProUpdateBillType(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Carrier Consignee
     * @param body (optional) 
     * @return OK
     */
    proUpdateCarrierConsignee(proNumber: string, body?: CarrierConsigneeDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdateCarrierConsignee/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdateCarrierConsignee(_response);
        });
    }

    protected processProUpdateCarrierConsignee(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Destination Terminal
     * @param body (optional) 
     * @return OK
     */
    proUpdateDestinationTerminal(body?: ProTerminalUpdateDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdateDestinationTerminal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdateDestinationTerminal(_response);
        });
    }

    protected processProUpdateDestinationTerminal(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Origin Terminal
     * @param body (optional) 
     * @return OK
     */
    proUpdateOriginTerminal(body?: ProTerminalUpdateDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdateOriginTerminal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdateOriginTerminal(_response);
        });
    }

    protected processProUpdateOriginTerminal(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Pay Terms
     * @return OK
     */
    proUpdatePayTerms(proNumber: string, payTerms: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdatePayTerms/{proNumber}/{payTerms}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        if (payTerms === undefined || payTerms === null)
            throw new Error("The parameter 'payTerms' must be defined.");
        url_ = url_.replace("{payTerms}", encodeURIComponent("" + payTerms));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdatePayTerms(_response);
        });
    }

    protected processProUpdatePayTerms(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Shipper
     * @param body (optional) 
     * @return OK
     */
    proUpdateShipper(proNumber: string, body?: ShipperDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdateShipper/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdateShipper(_response);
        });
    }

    protected processProUpdateShipper(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Update Shipper Consignee
     * @param body (optional) 
     * @return OK
     */
    proUpdateShipperConsignee(proNumber: string, body?: ShipperConsigneeDto | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UpdateShipperConsignee/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProUpdateShipperConsignee(_response);
        });
    }

    protected processProUpdateShipperConsignee(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Void Pro
     * @param body (optional) 
     * @return OK
     */
    voidPro(proNumber: string, body?: VoidProCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/VoidPro/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVoidPro(_response);
        });
    }

    protected processVoidPro(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    // NOTE: hand-added to match the backend UnvoidPro endpoint (mirrors voidPro above);
    // fold into the next NSwag regen.
    /**
     * Unvoid Pro
     * @param body (optional)
     * @return OK
     */
    unvoidPro(proNumber: string, body?: UnvoidProCommand | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Pro/UnvoidPro/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnvoidPro(_response);
        });
    }

    protected processUnvoidPro(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        // Success: the backend returns a raw boolean for OK requests (AutoWrapper
        // IgnoreWrapForOkRequests), so any 2xx means the unvoid was applied. Do NOT parse
        // the body here - a wrapped/empty body makes JSON.parse throw, which surfaced as a
        // false "failed to unvoid" toast even though the pro was already unvoided.
        if (status >= 200 && status < 300) {
            return Promise.resolve<boolean>(true);
        }
        // Error: throw an ApiException carrying the numeric HTTP status (not the parsed
        // ProblemDetails body) so callers can branch on error.status reliably. A 400 means
        // the pro was already not Voided (ProNotVoided guard); the caller treats that as benign.
        const _responseText = typeof response.data === "string" ? response.data : JSON.stringify(response.data);
        return throwException("Unvoid Pro failed.", status, _responseText, _headers);
    }
}

// NOTE: hand-added to match the backend AdminLineItemController (Admin-only force-edit /
// force-delete of a pro's line item, bypassing normal business rules); no NSwag regen has
// picked it up yet. Fold this whole class into the generated output on the next regen.
export interface AdminForceLineItemResultApiResultResponse {
    message?: string | undefined;
    result?: boolean;
}

/** Matches FreightOps_Core.Domain.Pros.Dto.ForceUpdateLineItemDto. */
export interface ForceUpdateLineItemDto {
    /** The SKU the line is currently stored under on the pro. */
    targetSku: string;
    /** The line as it should read after the override. Its sku may differ from targetSku. */
    lineItem: LineItemDto;
    /** Required free-text justification for the override. */
    reason: string;
}

/** Matches FreightOps_Core.Domain.Pros.Dto.ForceRemoveLineItemDto. */
export interface ForceRemoveLineItemDto {
    /** SKU of the line to remove. */
    sku: string;
    /** Required free-text justification for the override. */
    reason: string;
}

export interface IAdminLineItemClient {
    /**
     * Force Update Line Item
     * @param body (optional)
     * @return OK
     */
    forceUpdate(proNumber: string, body?: ForceUpdateLineItemDto | undefined): Promise<AdminForceLineItemResultApiResultResponse>;
    /**
     * Force Remove Line Item
     * @param body (optional)
     * @return OK
     */
    forceRemove(proNumber: string, body?: ForceRemoveLineItemDto | undefined): Promise<AdminForceLineItemResultApiResultResponse>;
}

export class AdminLineItemClient extends ApiBase implements IAdminLineItemClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        super();
        this.instance = instance || axios.create();
        this.baseUrl = baseUrl ?? "";
    }

    forceUpdate(proNumber: string, body?: ForceUpdateLineItemDto | undefined, cancelToken?: CancelToken): Promise<AdminForceLineItemResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/AdminLineItem/ForceUpdate/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForceLineItem(_response, "Force update line item failed.");
        });
    }

    forceRemove(proNumber: string, body?: ForceRemoveLineItemDto | undefined, cancelToken?: CancelToken): Promise<AdminForceLineItemResultApiResultResponse> {
        let url_ = this.baseUrl + "/api/AdminLineItem/ForceRemove/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForceLineItem(_response, "Force remove line item failed.");
        });
    }

    protected processForceLineItem(response: AxiosResponse, failureMessage: string): Promise<AdminForceLineItemResultApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status >= 200 && status < 300) {
            const _responseText = response.data;
            let result: AdminForceLineItemResultApiResultResponse = { result: true };
            try {
                result = JSON.parse(_responseText);
            } catch {
                // AutoWrapper's IgnoreWrapForOkRequests can leave the body empty for a bare
                // 200/204; a missing body still means the override was applied.
            }
            return Promise.resolve<AdminForceLineItemResultApiResultResponse>(result);
        }
        // Every guard override in AdminLineItemController (missing/blank reason, unknown sku,
        // sku already present, etc.) surfaces as a 400 with a human-readable ProblemDetails
        // message - surface that message rather than a generic one where possible.
        const _responseText = typeof response.data === "string" ? response.data : JSON.stringify(response.data);
        let parsed: any = null;
        try {
            parsed = JSON.parse(_responseText);
        } catch {
            // leave parsed null; throwException falls back to the raw text
        }
        return throwException(parsed?.message || parsed?.title || failureMessage, status, _responseText, _headers, parsed);
    }
}

export interface IThirdPartyClient {
    /**
     * Get Pro Tracking Unit label information
     * @return OK
     */
    proLabelData(proNumber: string): Promise<TrackingUnitLabelDtoListApiResultResponse>;
    /**
     * Get Pros scheduled for pickup
     * @return OK
     */
    proScheduledPickups(shipperCode: string, terminalCode: string): Promise<ProDtoListApiResultResponse>;
}

export class ThirdPartyClient extends ApiBase implements IThirdPartyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get Pro Tracking Unit label information
     * @return OK
     */
    proLabelData(proNumber: string, cancelToken?: CancelToken): Promise<TrackingUnitLabelDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/ThirdParty/Labels/pro/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProLabelData(_response);
        });
    }

    protected processProLabelData(response: AxiosResponse): Promise<TrackingUnitLabelDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TrackingUnitLabelDtoListApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrackingUnitLabelDtoListApiResultResponse>(null as any);
    }

    /**
     * Get Pros scheduled for pickup
     * @return OK
     */
    proScheduledPickups(shipperCode: string, terminalCode: string, cancelToken?: CancelToken): Promise<ProDtoListApiResultResponse> {
        let url_ = this.baseUrl + "/api/ThirdParty/Scheduled/shipper/{shipperCode}/terminal/{terminalCode}";
        if (shipperCode === undefined || shipperCode === null)
            throw new Error("The parameter 'shipperCode' must be defined.");
        url_ = url_.replace("{shipperCode}", encodeURIComponent("" + shipperCode));
        if (terminalCode === undefined || terminalCode === null)
            throw new Error("The parameter 'terminalCode' must be defined.");
        url_ = url_.replace("{terminalCode}", encodeURIComponent("" + terminalCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProScheduledPickups(_response);
        });
    }

    protected processProScheduledPickups(response: AxiosResponse): Promise<ProDtoListApiResultResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ProDtoListApiResultResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProDtoListApiResultResponse>(null as any);
    }
}

export interface IClientPrintClient {
    getGuideLabel(): Promise<void>;
    getManifestPrintJob(manifestId: string): Promise<void>;
    getProPrintJob(proNumber: string): Promise<void>;
    getTrackingUnitPrintJob(pro: string, barcode: string): Promise<void>;
}

export class ClientPrintClient extends ApiBase implements IClientPrintClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getGuideLabel( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ClientPrint/GetGuideLabel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGuideLabel(_response);
        });
    }

    protected processGetGuideLabel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getManifestPrintJob(manifestId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ClientPrint/GetManifestPrintJob/{manifestId}";
        if (manifestId === undefined || manifestId === null)
            throw new Error("The parameter 'manifestId' must be defined.");
        url_ = url_.replace("{manifestId}", encodeURIComponent("" + manifestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManifestPrintJob(_response);
        });
    }

    protected processGetManifestPrintJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getProPrintJob(proNumber: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ClientPrint/GetProPrintJob/{proNumber}";
        if (proNumber === undefined || proNumber === null)
            throw new Error("The parameter 'proNumber' must be defined.");
        url_ = url_.replace("{proNumber}", encodeURIComponent("" + proNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProPrintJob(_response);
        });
    }

    protected processGetProPrintJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getTrackingUnitPrintJob(pro: string, barcode: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ClientPrint/GetTrackingUnitPrintJob/{pro}/{barcode}";
        if (pro === undefined || pro === null)
            throw new Error("The parameter 'pro' must be defined.");
        url_ = url_.replace("{pro}", encodeURIComponent("" + pro));
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackingUnitPrintJob(_response);
        });
    }

    protected processGetTrackingUnitPrintJob(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ActivateTrackingUnitCommandDto {
    barcode?: string | undefined;
    proNumber?: string | undefined;
}

export interface ActiveManifestsForListViewModel {
    manifestId?: string | undefined;
}

export interface ActiveManifestsForListViewModelApiResultResponse {
    message?: string | undefined;
    result?: ActiveManifestsForListViewModel;
}

export interface ActiveProNumbersForListViewModel {
    proNumber?: string | undefined;
}

export interface ActiveProNumbersForListViewModelApiResultResponse {
    message?: string | undefined;
    result?: ActiveProNumbersForListViewModel;
}

export interface AddressDto {
    /** Address First Line */
    address1?: string | undefined;
    /** Address 2nd Line if needed */
    address2?: string | undefined;
    /** Apartment or Suite */
    aptSuite?: string | undefined;
    /** City */
    city?: string | undefined;
    /** State or Province if not US */
    state?: string | undefined;
    /** Postal Code */
    postalCode?: string | undefined;
}

export interface ApiProblemDetailsResponse {
    isError?: boolean;
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ApiResponse {
    version?: string | undefined;
    statusCode?: number;
    message?: string | undefined;
    isError?: boolean | undefined;
    responseException?: any | undefined;
    result?: any | undefined;
}

export interface AppendNote {
    barcode?: string | undefined;
    note?: string | undefined;
}

export interface ApplicationUserWithRoles {
    userId?: string | undefined;
    username?: string | undefined;
    email?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    homeTerminal?: string | undefined;
    role?: string[] | undefined;
}

export interface ApplicationUserWithRolesPaginatedList {
    results?: ApplicationUserWithRoles[] | undefined;
    pageNumber?: number;
    pageSize?: number;
    totalRecords?: number;
    totalPages?: number;
}

export interface ApplicationUserWithRolesPaginatedListApiResultResponse {
    message?: string | undefined;
    result?: ApplicationUserWithRolesPaginatedList;
}

export interface AppointmentDto {
    blockBegin?: Date;
    blockEnd?: Date;
    scheduledBy?: string | undefined;
    confirmed?: boolean;
}

export interface ArrivalDto {
    arrivalDate?: Date;
    arrived?: boolean;
    terminal?: string | undefined;
}

export interface AssignLocation {
    barcode?: string | undefined;
    location?: string | undefined;
}

export interface AssignOrphan {
    barcode?: string | undefined;
    proNumber?: string | undefined;
    trackingUnitBarcode?: string | undefined;
}

export interface AssignPickupCommandDto {
    proNumber?: string | undefined;
}

export interface AssignProToManifestCommandDto {
    proNumber?: string | undefined;
}

export interface AssignProsToLinehaulStopCommandDto {
    manifestId?: string | undefined;
    proNumbers?: string[] | undefined;
    terminal?: string | undefined;
}

export interface AssignTrailerCommand {
    manifestId?: string | undefined;
    trailer?: string | undefined;
}

export interface AssignedConsigneeDto {
    readonly code?: string | undefined;
    readonly name?: string | undefined;
}

export interface AuthenticateRequest {
    username: string;
    password: string;
}

export interface AuthenticateResponse {
    status?: string | undefined;
    message?: string | undefined;
}

export interface AuthorizedResponse {
    username?: string | undefined;
    token?: string | undefined;
    expiration?: Date;
}

export interface AuthorizedResponseApiResultResponse {
    message?: string | undefined;
    result?: AuthorizedResponse;
}

/** The party responsible for paying the invoice */
export interface BillToPartyDto {
    /** Abbreviated code for the bill to */
    code?: string | undefined;
    /** The name for teh Bill To Party */
    name?: string | undefined;
    address?: AddressDto;
}

/** Bill Type */
export enum BillTypeEnum {
    Standard = "Standard",
    FreeAstray = "FreeAstray",
    FactoryReturn = "FactoryReturn",
    B2B = "B2B",
    WGI = "WGI",
    WGNI = "WGNI",
    THR = "THR",
    RET = "RET",
    STD = "STD",
}

export interface CarrierConsigneeDto {
    /** Abbreviated code for the Carrier's consignee */
    code: string;
    /** Consignee's name */
    name: string;
    /** PO for Consignee */
    po?: string[] | undefined;
    address?: AddressDto;
    addressClassification?: string | undefined;
    hasDock?: string | undefined;
    contact?: ContactDto;
    notes?: string[] | undefined;
}

export interface CommandResult {
    readonly failureReason?: string | undefined;
    readonly isSuccess?: boolean;
    readonly hasWarnings?: boolean;
    readonly warnings?: Warning[] | undefined;
}

export interface CommandResultApiResultResponse {
    message?: string | undefined;
    result?: CommandResult;
}

export interface ConfirmOrphanAssignment {
    barcode?: string | undefined;
    proNumber?: string | undefined;
    trackingUnitBarcode?: string | undefined;
}

export interface ContactDto {
    phone?: string | undefined;
    phone2?: string | undefined;
    phone3?: string | undefined;
    email?: string | undefined;
    attn?: string | undefined;
}

export interface CreateBarcodeCommand {
    terminal?: string | undefined;
    carrierName?: string | undefined;
    trailerNumber?: string | undefined;
    note?: string | undefined;
}

export interface CreateDeliveryManifestDto {
    manifestId?: string | undefined;
    originTerminal?: string | undefined;
    /** Date This manifest is expected to be loaded */
    loadDate?: Date | undefined;
    /** Reference ID for TMS systems */
    tmsId?: string | undefined;
    /** Populate by 3rd party system */
    systemUnit?: string | undefined;
}

export interface CreateLinehaulManifestDto {
    trailer?: string | undefined;
    manifestId?: string | undefined;
    originTerminal?: string | undefined;
    destinationTerminal?: string | undefined;
}

export interface CreatePickupManifestDto {
    trailer?: string | undefined;
    manifestId?: string | undefined;
    destinationTerminal?: string | undefined;
}

export interface DamageItemCommand {
    proNumber?: string | undefined;
    barcode?: string | undefined;
    notes?: string | undefined;
}

export interface DeactivateTrackingUnitCommandDto {
    barcode?: string | undefined;
    proNumber?: string | undefined;
    notes?: string | undefined;
}

export interface DeliverProCommand {
    proNumber?: string | undefined;
    deliveryDate?: Date;
    user?: string | undefined;
    metaData?: MetaDto[] | undefined;
    hasExceptions?: boolean;
    exceptions?: string | undefined;
}

export interface DeliveryDto {
    deliveryDate?: Date;
    user?: string | undefined;
    metaData?: MetaDto[] | undefined;
    hasExceptions?: boolean;
    exceptions?: string | undefined;
}

export interface DeliveryNoteDto {
    /** Note */
    note?: string | undefined;
    /** Who to credit for entering */
    enteredBy?: string | undefined;
    /** Date note was entered (may not be today for instances imported from TMS) */
    enteredDate?: Date;
}

export interface DepartDto {
    departureDate?: Date;
    departed?: boolean;
    terminal?: string | undefined;
}

export interface DestroyItemCommand {
    proNumber?: string | undefined;
    barcode?: string | undefined;
    notes?: string | undefined;
}

export interface DoorDto {
    terminal?: string | undefined;
    barcode?: string | undefined;
    name?: string | undefined;
}

export interface DoorDtoListApiResultResponse {
    message?: string | undefined;
    result?: DoorDto[] | undefined;
}

export interface Filter {
    value?: string | undefined;
    matchMode?: MatchMode;
}

export interface GetInventoryForBayViewModel {
    terminal?: string | undefined;
    row?: string | undefined;
    bay?: string | undefined;
    inventoryItems?: InventoryItemViewModel[] | undefined;
}

export interface GetInventoryForBayViewModelApiResultResponse {
    message?: string | undefined;
    result?: GetInventoryForBayViewModel;
}

export interface GlobalSearchViewModel {
    pros?: string[] | undefined;
    trackingUnits?: string[] | undefined;
    manifests?: string[] | undefined;
}

export interface GlobalSearchViewModelApiResultResponse {
    message?: string | undefined;
    result?: GlobalSearchViewModel;
}

/** Hiding smart enum from UI */
export enum HandlingTypeEnum {
    HOLD = "HOLD",
    HOT = "HOT",
    STD = "STD",
}

export interface HubTerminalDto {
    code?: string | undefined;
    name?: string | undefined;
    number?: string | undefined;
    address?: AddressDto;
    isActive?: boolean;
    type?: string | undefined;
}

export interface HubTerminalDtoListApiResultResponse {
    message?: string | undefined;
    result?: HubTerminalDto[] | undefined;
}

export interface ImportProDto {
    /** Pro Number */
    proNumber: string;
    pickup?: PickupDto;
    originTerminal?: string | undefined;
    /** Array of Lineitems */
    lineitems: LineItemDto[];
    carrierConsignee: CarrierConsigneeDto;
    shipperConsignee?: ShipperConsigneeDto;
    shipper: ShipperDto;
    appointment?: AppointmentDto;
    /** Bill Type */
    billType?: string | undefined;
    /** Bill Type */
    routeVia?: string | undefined;
    billTo?: BillToPartyDto;
    handling?: HandlingTypeEnum;
    /** Date/Time order was created if pro is related to a 3PL order */
    orderDate?: Date | undefined;
    /** Date/Time pro was created in the host */
    hostDate?: Date | undefined;
    /** Total revenue of pro.
MOTE: this will be calculated as line items are added. */
    revenue?: number;
    /** Agent delivery cost is an important factor in load planning */
    agentDeliveryCost?: number;
    /** These are TMS defined values used to visually flag certain actions, as they might affect load planning 
or other operational issues.  Typical functions are:  CBD - Collect Before Delivery (Prepay Required), 
COD - Cash on Delivery, etc. */
    payTerms?: string | undefined;
    /** Any special notes about the pro */
    comment?: string | undefined;
    /** External Reference #, if needed, to store a value needed elsewhere */
    exRef?: string | undefined;
    /** Bill of Lading # - shipper's reference#. */
    bol?: string | undefined;
    /** Flag designating that the pro is ON HOLD and should NOT ship to Carrier Consignee until no longer on hold. */
    readonly onHold?: boolean;
    overrideLineItemQuantityCheck?: boolean;
}

export interface InboundHandling {
    proNumber?: string | undefined;
    location?: string | undefined;
    handling?: string | undefined;
    targetManifest?: string | undefined;
}

export interface InventoryDto {
    id?: string | undefined;
    location?: string | undefined;
    terminalNumber?: string | undefined;
    locationType?: string | undefined;
    proNumber?: string | undefined;
    sku?: string | undefined;
    description?: string | undefined;
    isValidated?: boolean;
    validatedBy?: string | undefined;
    validatedDate?: Date | undefined;
    validationException?: InventoryException;
    validationExceptions?: InventoryException[] | undefined;
    eventDate?: Date | undefined;
    lastUser?: string | undefined;
    locationDetail?: LocationDto;
}

export interface InventoryDtoPaginatedResult {
    page?: number;
    size?: number;
    count?: number;
    result?: InventoryDto[] | undefined;
}

export interface InventoryDtoPaginatedResultApiResultResponse {
    message?: string | undefined;
    result?: InventoryDtoPaginatedResult;
}

export interface InventoryException {
    readonly name?: string | undefined;
    readonly id?: number;
}

export interface InventoryItemViewModel {
    barcode?: string | undefined;
    terminalNumber?: string | undefined;
    location?: string | undefined;
    locationObject?: Location;
    proNumber?: string | undefined;
    sku?: string | undefined;
    description?: string | undefined;
    isValidated?: boolean;
    validatedBy?: string | undefined;
    validatedDate?: Date | undefined;
    validationException?: string | undefined;
    validationsExceptions?: string[] | undefined;
    eventDate?: Date | undefined;
    lastUser?: string | undefined;
}

export interface LaneAvailablePrefixesViewModel {
    prefixes?: string[] | undefined;
}

export interface LaneAvailablePrefixesViewModelApiResultResponse {
    message?: string | undefined;
    result?: LaneAvailablePrefixesViewModel;
}

export interface LaneDto {
    code?: string | undefined;
    description?: string | undefined;
    postalCodePrefixes?: string[] | undefined;
    areas?: { [key: string]: string[]; } | undefined;
}

export interface LaneDtoApiResultResponse {
    message?: string | undefined;
    result?: LaneDto;
}

export interface LaneDtoListApiResultResponse {
    message?: string | undefined;
    result?: LaneDto[] | undefined;
}

/** PrimeNG structure, used by lazy loading feature. Class LazyLoadEvent ported from PrimeNG to this library. Generally, populated by the PrimeNG filter feature. <example> An example of the JSON: {"first":0,"rows":3,"sortOrder":1,  "filters":{"ServerId":{"value":1,"matchMode":"eq"},    "Mailed":{"value":"false","matchMode":"eq"},    "Closed":{"value":"false","matchMode":"eq"},    "Special":{"value":"false","matchMode":"eq"}},   "globalFilter":null} </example> */
export interface LazyLoadEvent {
    /** First record #. */
    first?: number;
    /** # of rows to return (page size). */
    rows?: number;
    /** Sort field. */
    sortField?: string | undefined;
    /** Ascending or desending sort order. */
    sortOrder?: number | undefined;
    /** multiSortMeta, not implemented. */
    multiSortMeta?: any | undefined;
    /** A dictionary of filters.
Key of the dictionary is the field name, object is value(s)
and match mode. */
    filters?: { [key: string]: { [key: string]: any; }; } | undefined;
    /** globalFilter, not implemented. */
    globalFilter?: any | undefined;
    /** Show voided records. */
    showVoided?: boolean;
    page?: number;
}

export interface LegDto {
    type?: string | undefined;
    readonly isInbound?: boolean;
    readonly isOutbound?: boolean;
}

export interface LineItemDto {
    /** Must be greater than or equal to 1) */
    quantity: number;
    sku: LineitemSkuDto;
    /** Acknowledgment # - usually represents the shipper's sales order# */
    ack?: string | undefined;
    /** PO# - usually represents the consignee's reference # */
    po?: string | undefined;
    /** Bill of Lading # - shipper's reference#. */
    bol?: string | undefined;
    /** Is this line item being shipped to the specific attention of someone */
    attn?: string | undefined;
    /** Tag For - often times represents the end consumer (i.e. 'MARY JANE', 'JOHN SMITH')
and not necessarily the consignee */
    tagFor?: string | undefined;
    /** Gross weight of the line item */
    weight?: number;
    /** Often used in rating or productivity calculations as in, 
"Bill As weight 100' or "Pay As Weight CWT" of the line item.
Either be for a qty of 1 or for total qty of the
lineitem based on calculatedPerUnit Boolean value) */
    asWeight?: number;
    /** Total cubes of the line item */
    cubes?: number;
    /** Total # of seats for the line item.
Either be for a qty of 1 or for total qty of the
lineitem based on calculatedPerUnit Boolean value) */
    seats?: number;
    packType?: string | undefined;
    /** Number of items in a single shipping unit (i.e. 500 screws in a single carton)
Either be for a qty of 1 or for total qty of the
lineitem based on calculatedPerUnit Boolean value) */
    packItemCount?: number;
    /** Total revenue for the line item */
    revenue?: number;
    /** Total declared value for the line item */
    declaredValue?: number;
    notes?: string | undefined;
    /** External Reference #, if needed, to store a value needed elsewhere */
    exref?: string | undefined;
    /** Determines whether Cubes, Seats and Weight are calculted per unit or are total for lineitem.
Defaults to true. */
    readonly calculatedPerUnit?: boolean;
    trackingUnits?: TrackingUnitDto[] | undefined;
}

export interface LineitemQueueDto {
    manifestId?: string | undefined;
    stopOrder?: number;
    proNumber?: string | undefined;
    sku?: string | undefined;
    description?: string | undefined;
    shipper?: string | undefined;
    carrierConsignee?: string | undefined;
    shipperConsignee?: string | undefined;
    defaultLocation?: string | undefined;
    location?: string | undefined;
    section?: string | undefined;
    barcode?: string | undefined;
    isLoaded?: boolean;
    isUnloaded?: boolean;
    status?: string | undefined;
    returnTerminal?: string | undefined;
    lastTouchedBy?: string | undefined;
    statusLastUpdatedOn?: Date | undefined;
    wasManual?: boolean;
    handling?: string | undefined;
    targetManifest?: string | undefined;
}

export interface LineitemQueueDtoApiResultResponse {
    message?: string | undefined;
    result?: LineitemQueueDto;
}

export interface LineitemSkuDto {
    /** SKU Number */
    sku: string;
    /** For specifying another alternate SKU# for line item */
    altSku?: string | undefined;
    /** UPC# for SKU if specified */
    upc?: string | undefined;
    /** Manufacturer Name */
    manufacturerName?: string | undefined;
    /** Manufacturer's SKU# (usually same value as the main SKU# shown near the top above) */
    manufactureSku?: string | undefined;
    /** Freight Class */
    freightClass?: string | undefined;
    /** Description */
    description?: string | undefined;
    /** Style */
    style?: string | undefined;
    /** Lot# - if the line item has a specific Lot# associated to it from the shipper 
(this is a "pass through" value). */
    lot?: string | undefined;
    vendor?: VendorDto;
    /** Vendor SKU# (can be different than the manufacturer's SKU#). */
    vendorSku?: string | undefined;
    /** Vendor's description of the line item */
    vendorDescription?: string | undefined;
}

export interface ListManifestEventsViewModel {
    id?: string | undefined;
    version?: number;
    data?: string | undefined;
    timestamp?: Date;
    dotNetTypeName?: string | undefined;
    user?: string | undefined;
}

export interface ListManifestEventsViewModelListApiResultResponse {
    message?: string | undefined;
    result?: ListManifestEventsViewModel[] | undefined;
}

export interface ListProEventsViewModel {
    id?: string | undefined;
    version?: number;
    data?: string | undefined;
    timestamp?: Date;
    dotNetTypeName?: string | undefined;
    user?: string | undefined;
}

export interface ListProEventsViewModelListApiResultResponse {
    message?: string | undefined;
    result?: ListProEventsViewModel[] | undefined;
}

export interface ListProsByDateRangeViewModel {
    readonly pros?: ProDto[] | undefined;
    start?: Date;
    end?: Date;
    readonly count?: number;
}

export interface ListProsByDateRangeViewModelApiResultResponse {
    message?: string | undefined;
    result?: ListProsByDateRangeViewModel;
}

export interface LoadItemCommandDto {
    /** Item Barcode */
    barcode?: string | undefined;
    /** Trailer for loading */
    trailer?: string | undefined;
    /** User commiting action */
    user?: string | undefined;
    /** Trailer section to load to */
    section?: string | undefined;
    /** Optional flag to force load even if Manifest is not in a status that allows loading. */
    force?: boolean;
    wasManual?: boolean;
}

export interface Location {
    terminal?: string | undefined;
    barcode?: string | undefined;
    row?: string | undefined;
    bay?: string | undefined;
    level?: string | undefined;
    bin?: string | undefined;
    notes?: string | undefined;
}

export interface LocationBayViewModel {
    terminal?: string | undefined;
    row?: string | undefined;
    bay?: string | undefined;
    locations?: LocationDto[] | undefined;
}

export interface LocationDto {
    terminal?: string | undefined;
    barcode?: string | undefined;
    row?: string | undefined;
    bay?: string | undefined;
    level?: string | undefined;
    bin?: string | undefined;
    notes?: string | undefined;
}

export interface LocationDtoListApiResultResponse {
    message?: string | undefined;
    result?: LocationDto[] | undefined;
}

export interface LocationRowViewModel {
    terminal?: string | undefined;
    row?: string | undefined;
    bays?: LocationBayViewModel[] | undefined;
}

export interface LocationsListByTerminalGroupedViewModel {
    terminal?: string | undefined;
    rows?: LocationRowViewModel[] | undefined;
}

export interface LocationsListByTerminalGroupedViewModelApiResultResponse {
    message?: string | undefined;
    result?: LocationsListByTerminalGroupedViewModel;
}

export interface ManProDto {
    readonly proNumber?: string | undefined;
    readonly units?: number;
    readonly weight?: number;
    readonly cubes?: number;
    readonly seats?: number;
    readonly revenue?: number;
    readonly handling?: string | undefined;
    readonly assignedLocation?: string | undefined;
    readonly targetManifest?: string | undefined;
    readonly shouldPull?: boolean;
    readonly isReturned?: boolean;
}

export interface ManifestDto {
    readonly manifestId?: string | undefined;
    readonly trailer?: string | undefined;
    readonly transitStatus?: string | undefined;
    readonly statusLastUpdateOn?: Date | undefined;
    readonly door?: string | undefined;
    readonly carrier?: string | undefined;
    readonly loadDate?: Date;
    readonly inboundReleaseDate?: Date | undefined;
    readonly originTerminal?: string | undefined;
    readonly destTerminal?: string | undefined;
    readonly units?: number;
    readonly weight?: number;
    readonly cubes?: number;
    readonly seats?: number;
    readonly revenue?: number;
    readonly isPickup?: boolean;
    readonly manifestType?: string | undefined;
    leg?: LegDto;
    readonly created?: Date;
    readonly tag?: string | undefined;
}

export interface ManifestDtoListApiResultResponse {
    message?: string | undefined;
    result?: ManifestDto[] | undefined;
}

export interface ManifestDtoPaginatedResult {
    page?: number;
    size?: number;
    count?: number;
    result?: ManifestDto[] | undefined;
}

export interface ManifestDtoPaginatedResultApiResultResponse {
    message?: string | undefined;
    result?: ManifestDtoPaginatedResult;
}

export interface ManifestFullDetailDto {
    manifestId?: string | undefined;
    manifestType?: string | undefined;
    arrival?: ArrivalDto;
    inboundRelease?: ReleaseDto;
    trailer?: string | undefined;
    transitStatus?: string | undefined;
    door?: string | undefined;
    description?: string | undefined;
    notes?: string[] | undefined;
    carrier?: string | undefined;
    loadDate?: Date;
    originTerminal?: string | undefined;
    destTerminal?: string | undefined;
    active?: boolean;
    units?: number;
    weight?: number;
    cubes?: number;
    seats?: number;
    revenue?: number;
    isPickup?: boolean;
    created?: Date;
    stops?: StopDto[] | undefined;
    version?: number;
    leg?: LegDto;
    statusLastUpdateOn?: Date | undefined;
    tag?: string | undefined;
    queueTotal?: number;
    loaded?: number;
    unloaded?: number;
    xref?: string | undefined;
    systemUnit?: string | undefined;
    isAssignable?: boolean;
}

export interface ManifestFullDetailDtoApiResultResponse {
    message?: string | undefined;
    result?: ManifestFullDetailDto;
}

export interface ManifestFullDetailWithQueueDto {
    manifestId?: string | undefined;
    manifestType?: string | undefined;
    arrival?: ArrivalDto;
    inboundRelease?: ReleaseDto;
    trailer?: string | undefined;
    transitStatus?: string | undefined;
    door?: string | undefined;
    description?: string | undefined;
    notes?: string[] | undefined;
    carrier?: string | undefined;
    loadDate?: Date;
    originTerminal?: string | undefined;
    destTerminal?: string | undefined;
    active?: boolean;
    units?: number;
    weight?: number;
    cubes?: number;
    seats?: number;
    revenue?: number;
    isPickup?: boolean;
    created?: Date;
    stops?: StopDto[] | undefined;
    version?: number;
    leg?: LegDto;
    queue?: QueueDto;
}

export interface ManifestFullDetailWithQueueDtoApiResultResponse {
    message?: string | undefined;
    result?: ManifestFullDetailWithQueueDto;
}

export interface ManifestNumberDto {
    manifestNumber?: string | undefined;
}

export interface ManifestNumberDtoApiResultResponse {
    message?: string | undefined;
    result?: ManifestNumberDto;
}

export interface ManifestPreviewViewModel {
    manifestNumber?: string | undefined;
    manifestType?: string | undefined;
    status?: string | undefined;
    trailer?: string | undefined;
    door?: string | undefined;
}

export interface ManifestPreviewViewModelApiResultResponse {
    message?: string | undefined;
    result?: ManifestPreviewViewModel;
}

export interface ManifestProsViewModel {
    manifestNumber?: string | undefined;
    trailer?: string | undefined;
    door?: string | undefined;
    activeTerminal?: string | undefined;
    status?: string | undefined;
    manifestType?: string | undefined;
    destinationTerminal?: string | undefined;
    stops?: ManifestStopViewModel[] | undefined;
}

export interface ManifestProsViewModelApiResultResponse {
    message?: string | undefined;
    result?: ManifestProsViewModel;
}

export interface ManifestQueueHistoryDto {
    id?: string | undefined;
    manifestId?: string | undefined;
    description?: string | undefined;
    by?: string | undefined;
    when?: Date | undefined;
}

export interface ManifestQueueHistoryDtoPaginatedResult {
    page?: number;
    size?: number;
    count?: number;
    result?: ManifestQueueHistoryDto[] | undefined;
}

export interface ManifestQueueHistoryDtoPaginatedResultApiResultResponse {
    message?: string | undefined;
    result?: ManifestQueueHistoryDtoPaginatedResult;
}

export interface ManifestStatus {
    readonly name?: string | undefined;
    readonly id?: number;
}

export interface ManifestStatusListApiResultResponse {
    message?: string | undefined;
    result?: ManifestStatus[] | undefined;
}

export interface ManifestStatusLog {
    id?: string | undefined;
    messageDate?: Date;
    readonly statusEventDate?: string | undefined;
    readonly statusEventTime?: string | undefined;
    statusEventNumber?: number;
    statusEventBy?: string | undefined;
    manifestId?: string | undefined;
    manifestTemplateType?: string | undefined;
    manifestTransitStatus?: string | undefined;
    originTerminal?: string | undefined;
    destinationTerminal?: string | undefined;
    door?: string | undefined;
    trailer?: string | undefined;
}

export interface ManifestStatusLogPaginatedResult {
    page?: number;
    size?: number;
    count?: number;
    result?: ManifestStatusLog[] | undefined;
}

export interface ManifestStatusLogPaginatedResultApiResultResponse {
    message?: string | undefined;
    result?: ManifestStatusLogPaginatedResult;
}

export interface ManifestStopViewModel {
    order?: number;
    pros?: ProPreviewViewModel[] | undefined;
}

export enum MatchMode {
    CONTAINS = "CONTAINS",
    EQUALS = "EQUALS",
}

export interface MetaDto {
    key?: string | undefined;
    value?: string | undefined;
}

export interface OrphanDto {
    id?: string | undefined;
    barcode?: string | undefined;
    terminalId?: string | undefined;
    status?: string | undefined;
    location?: string | undefined;
    lastKnownManifest?: string | undefined;
    lastKnownProNumber?: string | undefined;
    carrierName?: string | undefined;
    trailerNumber?: string | undefined;
    assignedTo?: string | undefined;
    createdDate?: Date;
    lastModifiedDate?: Date | undefined;
    notes?: string[] | undefined;
}

export interface OrphanDtoApiResultResponse {
    message?: string | undefined;
    result?: OrphanDto;
}

export interface OrphanDtoPaginatedResult {
    page?: number;
    size?: number;
    count?: number;
    result?: OrphanDto[] | undefined;
}

export interface OrphanDtoPaginatedResultApiResultResponse {
    message?: string | undefined;
    result?: OrphanDtoPaginatedResult;
}

export interface OrphanItemCommand {
    proNumber?: string | undefined;
    barcode?: string | undefined;
    notes?: string | undefined;
}

export interface OsdCode {
    readonly name?: string | undefined;
    readonly id?: number;
}

export interface PaginationFilter {
    first?: number;
    rows?: number;
    sortField?: string | undefined;
    sortOrder?: SortOrder;
    filters?: { [key: string]: Filter; } | undefined;
}

export interface PickupDto {
    trailer?: string | undefined;
    date?: Date;
}

export interface PostalCodeDto {
    code?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    stateAbbrev?: string | undefined;
    county?: string | undefined;
    latitude?: number;
    longitude?: number;
    accuracy?: number;
}

export interface PostalCodeDtoListApiResultResponse {
    message?: string | undefined;
    result?: PostalCodeDto[] | undefined;
}

export interface PostalCodePrefixListViewModel {
    prefixes?: string[] | undefined;
}

export interface PostalCodePrefixListViewModelApiResultResponse {
    message?: string | undefined;
    result?: PostalCodePrefixListViewModel;
}

export interface PostalCodeShortDto {
    code?: string | undefined;
    state?: string | undefined;
    stateAbbrev?: string | undefined;
}

export interface PostalCodeShortDtoApiResultResponse {
    message?: string | undefined;
    result?: PostalCodeShortDto;
}

export interface PostalCodeShortListDto {
    postalCodes?: RequestPostalCodeShortDto[] | undefined;
}

export interface PostalCodeShortListDtoApiResultResponse {
    message?: string | undefined;
    result?: PostalCodeShortListDto;
}

export interface PreviousStatusViewModel {
    currentStatus?: string | undefined;
    currentVersion?: number;
    previousStatus?: string | undefined;
    previousVersion?: number;
}

export interface PreviousStatusViewModelApiResultResponse {
    message?: string | undefined;
    result?: PreviousStatusViewModel;
}

export interface ProDto {
    proNumber?: string | undefined;
    parentProNumber?: string | undefined;
    childProNumbers?: string[] | undefined;
    currentManifest?: string | undefined;
    inboundManifest?: string | undefined;
    outboundManifest?: string | undefined;
    originTerminal?: string | undefined;
    activeTerminal?: string | undefined;
    status?: string | undefined;
    billType?: string | undefined;
    routeVia?: string | undefined;
    handling?: string | undefined;
    orderDate?: Date | undefined;
    hostDate?: Date | undefined;
    revenue?: number;
    agentDeliveryCost?: number;
    comment?: string | undefined;
    exRef?: string | undefined;
    bol?: string | undefined;
    payTerms?: string | undefined;
    lineItems?: LineItemDto[] | undefined;
    shipperConsignee?: ShipperConsigneeDto;
    carrierConsignee?: CarrierConsigneeDto;
    shipper?: ShipperDto;
    billToParty?: BillToPartyDto;
    appointment?: string | undefined;
    appointmentDetail?: AppointmentDto;
    deliveryDetail?: DeliveryDto;
    voidDetail?: VoidDetailsDto;
    units?: number;
    weight?: number;
    cubes?: number;
    seats?: number;
    packTypes?: string | undefined;
    onHold?: boolean;
    age?: number;
    created?: Date;
    deliveryNotes?: DeliveryNoteDto[] | undefined;
    pickup?: PickupDto;
    destinationTerminal?: string | undefined;
    workflow?: string | undefined;
    lane?: string | undefined;
    laneDescription?: string | undefined;
}

export interface ProDtoApiResultResponse {
    message?: string | undefined;
    result?: ProDto;
}

export interface ProDtoListApiResultResponse {
    message?: string | undefined;
    result?: ProDto[] | undefined;
}

export interface ProDtoPaginatedResult {
    page?: number;
    size?: number;
    count?: number;
    result?: ProDto[] | undefined;
}

export interface ProDtoPaginatedResultApiResultResponse {
    message?: string | undefined;
    result?: ProDtoPaginatedResult;
}

export interface ProNumberDto {
    proNumber?: string | undefined;
}

export interface ProNumberDtoApiResultResponse {
    message?: string | undefined;
    result?: ProNumberDto;
}

export interface ProPreviewViewModel {
    proNumber?: string | undefined;
    unloaded?: number;
    quantity?: number;
    status?: string | undefined;
}

export interface ProSegmentsViewModel {
    manifestId?: string | undefined;
    template?: string | undefined;
    isCompleted?: boolean;
    completedOn?: Date | undefined;
}

export interface ProSegmentsViewModelListApiResultResponse {
    message?: string | undefined;
    result?: ProSegmentsViewModel[] | undefined;
}

export interface ProStatus {
    readonly name?: string | undefined;
    readonly id?: number;
}

export interface ProStatusListApiResultResponse {
    message?: string | undefined;
    result?: ProStatus[] | undefined;
}

export interface ProStatusLog {
    id?: string | undefined;
    messageDate?: Date;
    readonly statusEventDate?: string | undefined;
    readonly statusEventTime?: string | undefined;
    statusEventNumber?: number;
    statusEventBy?: string | undefined;
    proNumber?: string | undefined;
    transitStatus?: string | undefined;
    location?: string | undefined;
    packType?: string | undefined;
}

export interface ProStatusLogPaginatedResult {
    page?: number;
    size?: number;
    count?: number;
    result?: ProStatusLog[] | undefined;
}

export interface ProStatusLogPaginatedResultApiResultResponse {
    message?: string | undefined;
    result?: ProStatusLogPaginatedResult;
}

export interface ProTerminalUpdateDto {
    proNumber?: string | undefined;
    terminal?: string | undefined;
}

export interface ProWithIssuesResult {
    proNumber?: string | undefined;
    activeTerminal?: string | undefined;
    shortCount?: number;
    deactivatedCount?: number;
    trackingUnitIssues?: TrackingUnitIssue[] | undefined;
}

export interface ProWithIssuesResultListApiResultResponse {
    message?: string | undefined;
    result?: ProWithIssuesResult[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface PullLocationDTO {
    manifestId?: string | undefined;
    proNumber?: string | undefined;
    location?: string | undefined;
    isXDock?: boolean;
}

export interface QueueDto {
    readonly loaded?: number;
    readonly unloaded?: number;
    readonly total?: number;
    queuedItems?: LineitemQueueDto[] | undefined;
}

export interface QueueDtoApiResultResponse {
    message?: string | undefined;
    result?: QueueDto;
}

export interface RegisterModel {
    username: string;
    email: string;
    password: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    homeTerminal?: string | undefined;
}

export interface ReleaseCommandDto {
    door?: string | undefined;
}

export interface ReleaseDto {
    releaseDate?: Date;
    terminal?: string | undefined;
    door?: string | undefined;
    released?: boolean;
}

export interface ReleaseOutboundDto {
    door?: string | undefined;
    trailer?: string | undefined;
}

export interface RelocateItemCommandDto {
    barcode?: string | undefined;
    location?: string | undefined;
}

export interface RelocateItemV2Command {
    proNumber?: string | undefined;
    barcode?: string | undefined;
    location?: string | undefined;
    user?: string | undefined;
}

export interface RelocateProCommandDto {
    location?: string | undefined;
    proNumber?: string | undefined;
}

export interface ReopenCommand {
    manifestId?: string | undefined;
}

export interface ReorderStopsCommandDto {
    manifestId?: string | undefined;
    stopOrders?: StopOrderDto[] | undefined;
}

export enum ReportingPeriod {
    Hourly = "Hourly",
    Daily = "Daily",
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export interface RequestPostalCodeShortDto {
    postalCode?: string | undefined;
    state?: string | undefined;
    stateAbbrev?: string | undefined;
}

export interface ReturnItemCommand {
    manifestId?: string | undefined;
    barcode?: string | undefined;
    location?: string | undefined;
    user?: string | undefined;
}

export interface ReturnProToDockCommand {
    manifestId?: string | undefined;
    proNumber?: string | undefined;
    terminal?: string | undefined;
    defaultLocation?: string | undefined;
    user?: string | undefined;
}

export interface ScanTrackingUnitCommandDto {
    barcode?: string | undefined;
    proNumber?: string | undefined;
    state?: boolean;
}

export interface SetDefaultLocationsForProCommandDto {
    manifestId?: string | undefined;
    proNumber?: string | undefined;
    location?: string | undefined;
}

export interface ShipperConsigneeDto {
    code: string;
    name: string;
    po?: string[] | undefined;
    address?: AddressDto;
    contact?: ContactDto;
    addressClassification?: string | undefined;
    hasDock?: string | undefined;
    notes?: string[] | undefined;
}

export interface ShipperDto {
    code: string;
    name: string;
    ack?: string[] | undefined;
    bol?: string | undefined;
    address?: AddressDto;
    contact?: ContactDto;
    addressClassification?: string | undefined;
    hasDock?: string | undefined;
}

export interface ShortItemCommand {
    proNumber?: string | undefined;
    barcode?: string | undefined;
    notes?: string | undefined;
}

export interface ShortItemsCommand {
    proNumber?: string | undefined;
    quantity?: number;
    sku?: string | undefined;
    notes?: string | undefined;
}

export enum SortOrder {
    ASC = "ASC",
    DESC = "DESC",
}

export interface SplitProCommand {
    proNumber?: string | undefined;
    lineItemBarcodes?: string[] | undefined;
}

export interface StopDto {
    order?: number;
    address?: AddressDto;
    pros?: ManProDto[] | undefined;
    isLinehaulStop?: boolean;
}

export interface StopOrderDto {
    order?: number;
    address?: AddressDto;
}

export interface StowItemCommandDto {
    barcode?: string | undefined;
    location?: string | undefined;
    user?: string | undefined;
    wasManual?: boolean;
}

export interface TerminalProductivityResponse {
    id?: string | undefined;
    terminal?: string | undefined;
    loadedUnits?: number;
    loadedWeight?: number;
    loadedCubes?: number;
    unloadedUnits?: number;
    unloadedWeight?: number;
    unloadedCubes?: number;
    relocatedUnits?: number;
    relocatedWeight?: number;
    relocatedCubes?: number;
    stagedUnits?: number;
    stagedWeight?: number;
    stagedCubes?: number;
    stowedUnits?: number;
    stowedWeight?: number;
    stowedCubes?: number;
}

export interface TerminalProductivityViewModel {
    period?: ReportingPeriod;
    startDate?: Date;
    endDate?: Date;
    terminalCode?: string | undefined;
    dimensions?: TerminalProductivityResponse[] | undefined;
}

export interface TerminalProductivityViewModelApiResultResponse {
    message?: string | undefined;
    result?: TerminalProductivityViewModel;
}

export interface TrackingUnitDetailViewModel {
    proNumber?: string | undefined;
    trackingUnit?: TrackingUnitLookup;
    history?: TrackingUnitHistory;
}

export interface TrackingUnitDetailViewModelApiResultResponse {
    message?: string | undefined;
    result?: TrackingUnitDetailViewModel;
}

export interface TrackingUnitDto {
    id?: string;
    barcode?: string | undefined;
    deactivated?: boolean;
    location?: string | undefined;
    wasScanned?: boolean;
    packType?: string | undefined;
    osdCode?: string | undefined;
}

export interface TrackingUnitEvent {
    eventId?: string;
    event?: string | undefined;
    scanType?: string | undefined;
    eventDate?: Date | undefined;
    user?: string | undefined;
}

/** TrackingUnitExceptionLog */
export interface TrackingUnitExceptionLog {
    id?: string | undefined;
    messageDate?: Date;
    readonly statusEventDate?: string | undefined;
    readonly statusEventTime?: string | undefined;
    statusEventNumber?: number;
    statusEventBy?: string | undefined;
    barcode?: string | undefined;
    proNumber?: string | undefined;
    transitStatus?: string | undefined;
    location?: string | undefined;
    packType?: string | undefined;
    osdCode?: string | undefined;
    osdNotes?: string | undefined;
}

export interface TrackingUnitExceptionLogPaginatedResult {
    page?: number;
    size?: number;
    count?: number;
    result?: TrackingUnitExceptionLog[] | undefined;
}

export interface TrackingUnitExceptionLogPaginatedResultApiResultResponse {
    message?: string | undefined;
    result?: TrackingUnitExceptionLogPaginatedResult;
}

export interface TrackingUnitHistory {
    id?: string | undefined;
    events?: { [key: string]: TrackingUnitEvent; } | undefined;
}

export interface TrackingUnitHistoryApiResultResponse {
    message?: string | undefined;
    result?: TrackingUnitHistory;
}

export interface TrackingUnitIssue {
    barcode?: string | undefined;
    location?: string | undefined;
    isShorted?: boolean;
    isDeactivated?: boolean;
    osdCode?: OsdCode;
}

export interface TrackingUnitLabelDto {
    proNumber?: string | undefined;
    shipperConsignee?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    cityStateZip?: string | undefined;
    shipperName?: string | undefined;
    sku?: string | undefined;
    description?: string | undefined;
    po?: string | undefined;
    ack?: string | undefined;
    bol?: string | undefined;
    index?: number;
    total?: number;
    workflow?: string | undefined;
    originTerminal?: string | undefined;
    pickupDate?: string | undefined;
    barcode?: string | undefined;
    skuSummary?: string | undefined;
    countSummary?: string | undefined;
    readonly weightSummary?: string | undefined;
    readonly cubesSummary?: string | undefined;
}

export interface TrackingUnitLabelDtoListApiResultResponse {
    message?: string | undefined;
    result?: TrackingUnitLabelDto[] | undefined;
}

export interface TrackingUnitLookup {
    id?: string | undefined;
    manifestId?: string | undefined;
    proNumber?: string | undefined;
    shipperConsignee?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    cityStateZip?: string | undefined;
    shipperName?: string | undefined;
    sku?: string | undefined;
    description?: string | undefined;
    po?: string | undefined;
    ack?: string | undefined;
    bol?: string | undefined;
    barcode?: string | undefined;
    deactivated?: boolean;
    location?: string | undefined;
    defaultLocation?: string | undefined;
    trailer?: string | undefined;
    wasScanned?: boolean;
    packType?: string | undefined;
    section?: string | undefined;
    osdCode?: OsdCode;
    osdNotes?: string | undefined;
}

export interface UnassignedProFromManifestCommandDto {
    proNumber?: string | undefined;
    readonly manifestId?: string | undefined;
}

export interface UndeliverProCommand {
    proNumber?: string | undefined;
}

export interface UndepartCommand {
    manifestId?: string | undefined;
}

export interface UnloadItemCommandDto {
    barcode?: string | undefined;
    user?: string | undefined;
    packType?: string | undefined;
    wasManual?: boolean;
}

export interface UnloadItemCommandResponse {
    manifestId?: string | undefined;
    barcode?: string | undefined;
    location?: string | undefined;
    defaultLocation?: string | undefined;
    packType?: string | undefined;
    result?: CommandResult;
}

export interface UnloadItemCommandResponseApiResultResponse {
    message?: string | undefined;
    result?: UnloadItemCommandResponse;
}

export interface UpdateCarrierCommandDto {
    carrier?: string | undefined;
}

export interface UpdateDestinationTerminalCommandDto {
    terminal?: string | undefined;
}

export interface UpdateMetadata {
    barcode?: string | undefined;
    carrierName?: string | undefined;
    trailerNumber?: string | undefined;
    readonly lastKnownManifest?: string | undefined;
    readonly lastKnownProNumber?: string | undefined;
}

export interface UpdateOriginTerminalCommandDto {
    terminal?: string | undefined;
}

export interface UpdatePackTypeForTrackingUnitCommandDto {
    barcode?: string | undefined;
    packType?: string | undefined;
}

export interface UpdatePasswordModel {
    username: string;
    password: string;
}

export interface UpdateRegistrationModel {
    username: string;
    email: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    homeTerminal?: string | undefined;
}

export interface UpdateTagCommandDto {
    tag?: string | undefined;
}

export interface UpdateUserRoleModel {
    username: string;
    role: string;
}

export interface UpdateXrefCommandDto {
    xref?: string | undefined;
}

export interface UpsertLaneDto {
    code?: string | undefined;
    description?: string | undefined;
    areas?: { [key: string]: string[]; } | undefined;
}

export interface ValidateCommandDto {
    barcode?: string | undefined;
    terminal?: string | undefined;
    location?: string | undefined;
}

export interface VendorDto {
    name?: string | undefined;
    code?: string | undefined;
    address?: AddressDto;
}

export interface VoidDetailsDto {
    voidedDate?: Date;
    user?: string | undefined;
    metaData?: MetaDto[] | undefined;
    hasExceptions?: boolean;
    exceptions?: string | undefined;
}

// NOTE: hand-added to match the backend UnvoidPro endpoint; fold into the next NSwag regen.
export interface UnvoidProCommand {
    proNumber?: string | undefined;
}

export interface VoidProCommand {
    proNumber?: string | undefined;
    voidedDate?: Date;
    user?: string | undefined;
    metaData?: MetaDto[] | undefined;
    hasExceptions?: boolean;
    exceptions?: string | undefined;
}

export interface Warning {
    title?: string | undefined;
    description?: string | undefined;
}

export interface ZoneDto {
    number?: string | undefined;
    name?: string | undefined;
    code?: string | undefined;
    terminal?: string | undefined;
    lanes?: string[] | undefined;
    targetRows?: LocationDto[] | undefined;
    alternateRows?: LocationDto[] | undefined;
    assignedConsignees?: AssignedConsigneeDto[] | undefined;
}

export interface ZoneDtoApiResultResponse {
    message?: string | undefined;
    result?: ZoneDto;
}

export interface ZoneDtoListApiResultResponse {
    message?: string | undefined;
    result?: ZoneDto[] | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
